// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-us-page {
  font-family: "Open Sans", sans-serif !important;
  color: #ffffff;
  line-height: 1.6;
  overflow-x: hidden;
  background: #0a0c10;
  min-height: 100vh;
  margin-top: 0 !important;
}
.about-us-page .main-container {
  margin-top: 0 !important;
  padding-top: 0 !important;
}
.about-us-page .page-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  width: 100%;
  margin-top: 0 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  background: rgba(10, 12, 16, 0.95);
  -webkit-backdrop-filter: blur(20px);
          backdrop-filter: blur(20px);
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  /* Keep sun/moon visible against thumb (esp. when global body.theme-dark + MDC conflict) */
}
.about-us-page .page-header ~ :global(.flow-sidebar) {
  z-index: 1001 !important;
}
.about-us-page .page-header.scrolled {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  background: rgba(10, 12, 16, 0.98);
}
.about-us-page .page-header .header-container {
  max-width: 100%;
  width: 100%;
  padding: 0 16px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
}
@media (max-width: 768px) {
  .about-us-page .page-header .header-container {
    padding: 0 16px;
    gap: 16px;
    height: 56px;
  }
}
.about-us-page .page-header .header-left {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
  margin-right: 0;
}
.about-us-page .page-header .menu-button {
  background: none;
  border: none;
  color: #ffffff;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
  flex-shrink: 0;
}
.about-us-page .page-header .menu-button:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
.about-us-page .page-header .menu-button mat-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.about-us-page .page-header .header-logo {
  cursor: pointer;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.about-us-page .page-header .header-logo img {
  height: 45px;
  width: auto;
  display: block;
}
@media (max-width: 768px) {
  .about-us-page .page-header .header-logo img {
    height: 35px;
  }
}
.about-us-page .page-header .header-nav {
  display: flex;
  align-items: center;
  gap: 40px;
  flex: 1;
  justify-content: center;
  min-width: 0;
  margin: 0 auto;
}
@media (max-width: 1024px) {
  .about-us-page .page-header .header-nav {
    gap: 24px;
  }
}
@media (max-width: 768px) {
  .about-us-page .page-header .header-nav {
    display: none;
  }
}
.about-us-page .page-header .header-nav .nav-link {
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  color: rgba(255, 255, 255, 0.5);
  text-decoration: none;
  transition: color 0.3s ease;
  cursor: pointer;
  white-space: nowrap;
  padding: 4px 0;
}
.about-us-page .page-header .header-nav .nav-link:hover {
  color: #ffffff;
}
.about-us-page .page-header .header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
  flex-shrink: 0;
}
.about-us-page .page-header .theme-toggle-button {
  border-radius: 999px;
  padding: 2px;
  background: transparent;
  border: none;
  outline: none;
  box-shadow: none;
  cursor: pointer;
}
.about-us-page .page-header .theme-toggle-button:focus, .about-us-page .page-header .theme-toggle-button:active, .about-us-page .page-header .theme-toggle-button:focus-visible {
  border: none;
  outline: none;
  box-shadow: none;
}
.about-us-page .page-header .theme-toggle-button:hover {
  background: transparent;
}
.about-us-page .page-header .theme-toggle-track {
  width: 48px;
  height: 26px;
  border-radius: 999px;
  background: #e5e7eb;
  border: none;
  display: inline-flex;
  align-items: center;
  padding: 1px;
  transition: background-color 0.2s ease;
}
.about-us-page .page-header .theme-toggle-track.active {
  background: #1f2937;
}
.about-us-page .page-header .theme-toggle-thumb {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #ffffff;
  color: #6b7280;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transform: translateX(0);
  transition: transform 0.2s ease, color 0.2s ease, background-color 0.2s ease;
}
.about-us-page .page-header .theme-toggle-track.active .theme-toggle-thumb {
  transform: translateX(22px);
  color: #ffffff;
  background: #0f172a;
}
.about-us-page .page-header .theme-toggle-thumb mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.about-us-page .page-header .theme-toggle-track.active .theme-toggle-thumb mat-icon {
  color: #ffffff !important;
}
.about-us-page .page-header .theme-toggle-track:not(.active) .theme-toggle-thumb mat-icon {
  color: #6b7280 !important;
}
.about-us-page .page-header .btn-get-started {
  background: #ffffff;
  color: #000000;
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  flex-shrink: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-left: 0;
}
.about-us-page .page-header .btn-get-started:hover {
  background: rgba(255, 255, 255, 0.95);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
@media (max-width: 768px) {
  .about-us-page .page-header .btn-get-started {
    padding: 8px 16px;
    font-size: 12px;
  }
}
.about-us-page .container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px !important;
}
@media (max-width: 768px) {
  .about-us-page .container {
    padding: 0 24px !important;
  }
}
.about-us-page .problem-section .container {
  max-width: 896px !important;
}
.about-us-page .insight-section .container {
  max-width: 768px !important;
}
.about-us-page .what-section .container {
  max-width: 1280px !important;
}
.about-us-page .why-section .container {
  max-width: 896px !important;
}
.about-us-page .founder-section .container {
  max-width: 896px !important;
}
.about-us-page .vision-section .container {
  max-width: 768px !important;
}
.about-us-page .values-section .container {
  max-width: 1280px !important;
}
.about-us-page .closing-section .container {
  max-width: 896px !important;
}
.about-us-page .section {
  padding: 96px 24px !important;
  position: relative;
  visibility: visible !important;
  opacity: 1 !important;
}
@media (max-width: 768px) {
  .about-us-page .section {
    padding: 60px 24px !important;
  }
}
.about-us-page .hero-section {
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0a0c10 !important;
  color: #ffffff !important;
  text-align: center;
  padding: 40px 24px 120px !important;
  margin-top: 10px;
  position: relative;
  overflow: hidden;
  visibility: visible !important;
  opacity: 1 !important;
}
@media (max-width: 768px) {
  .about-us-page .hero-section {
    padding: 32px 24px 80px !important;
    margin-top: 10px;
  }
}
.about-us-page .hero-section::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: radial-gradient(circle at 1px 1px, rgba(255, 255, 255, 0.05) 1px, transparent 0);
  background-size: 40px 40px;
  pointer-events: none;
}
.about-us-page .hero-section::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(94, 161, 216, 0.1), transparent);
  pointer-events: none;
}
.about-us-page .hero-section .hero-content {
  max-width: 1000px;
  padding: 0 24px;
  position: relative;
  z-index: 2;
}
.about-us-page .hero-section .hero-badge {
  background: rgba(94, 161, 216, 0.1) !important;
  color: #5ea1d8 !important;
  border: 1px solid rgba(94, 161, 216, 0.3) !important;
  padding: 4px 12px !important;
  font-size: 10px !important;
  font-weight: 700 !important;
  letter-spacing: 0.2em !important;
  text-transform: uppercase !important;
  border-radius: 9999px !important;
  margin-bottom: 32px !important;
  display: inline-block !important;
  opacity: 1 !important;
  visibility: visible !important;
}
.about-us-page .hero-section .hero-title {
  font-family: "Open Sans", sans-serif !important;
  font-size: 64px;
  font-weight: 700;
  line-height: 1.1;
  margin-bottom: 32px;
  letter-spacing: -0.02em;
  background: linear-gradient(to right, #ffffff, rgb(148, 163, 184)) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  background-clip: text !important;
  opacity: 1 !important;
  visibility: visible !important;
}
@media (max-width: 768px) {
  .about-us-page .hero-section .hero-title {
    font-size: 40px;
  }
}
.about-us-page .hero-section .hero-subheading {
  font-size: 24px !important;
  font-weight: 400 !important;
  line-height: 1.7 !important;
  color: #94a3b8 !important;
  max-width: 800px !important;
  margin: 0 auto 16px !important;
  opacity: 1 !important;
  visibility: visible !important;
}
@media (max-width: 768px) {
  .about-us-page .hero-section .hero-subheading {
    font-size: 20px !important;
  }
}
.about-us-page .hero-section .hero-microline {
  font-size: 18px !important;
  font-weight: 400 !important;
  line-height: 1.6 !important;
  color: #64748b !important;
  max-width: 800px !important;
  margin: 0 auto !important;
  opacity: 1 !important;
  visibility: visible !important;
}
@media (max-width: 768px) {
  .about-us-page .hero-section .hero-microline {
    font-size: 16px !important;
  }
}
.about-us-page .problem-section {
  background: rgba(0, 0, 0, 0.5) !important;
  border-top: 1px solid rgba(255, 255, 255, 0.05) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05) !important;
  padding: 96px 24px !important;
  position: relative !important;
  opacity: 1 !important;
  visibility: visible !important;
}
.about-us-page .problem-section .section-heading {
  font-size: 48px !important;
  font-weight: 700 !important;
  margin-bottom: 48px !important;
  color: #ffffff !important;
  opacity: 1 !important;
  visibility: visible !important;
  line-height: 1.2 !important;
  letter-spacing: -0.02em !important;
}
@media (max-width: 768px) {
  .about-us-page .problem-section .section-heading {
    font-size: 32px !important;
  }
}
.about-us-page .problem-section .problem-content {
  max-width: 896px !important;
  margin: 0 auto !important;
}
.about-us-page .problem-section .body-copy {
  font-size: 18px !important;
  line-height: 1.8 !important;
  color: #cbd5e1 !important;
  margin-bottom: 32px !important;
  font-weight: 400 !important;
  opacity: 1 !important;
  visibility: visible !important;
}
.about-us-page .problem-section .pull-quote {
  margin: 48px 0 !important;
  padding: 32px !important;
  background: rgba(30, 41, 59, 0.5) !important;
  border-left: 4px solid #5ea1d8 !important;
  border-radius: 0 12px 12px 0 !important;
  opacity: 1 !important;
  visibility: visible !important;
}
.about-us-page .problem-section .pull-quote p {
  font-size: 32px !important;
  font-weight: 500 !important;
  font-style: italic !important;
  color: #ffffff !important;
  margin: 0 !important;
  line-height: 1.4 !important;
  opacity: 1 !important;
  visibility: visible !important;
}
@media (max-width: 768px) {
  .about-us-page .problem-section .pull-quote p {
    font-size: 24px !important;
  }
}
.about-us-page .insight-section {
  padding: 128px 24px !important;
  text-align: center;
  background: #0a0c10 !important;
  position: relative !important;
  overflow: hidden !important;
  visibility: visible !important;
}
.about-us-page .insight-section::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: radial-gradient(circle at 1px 1px, rgba(255, 255, 255, 0.05) 1px, transparent 0);
  background-size: 40px 40px;
  pointer-events: none;
}
.about-us-page .insight-section::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(94, 161, 216, 0.1), transparent);
  pointer-events: none;
}
.about-us-page .insight-section .insight-content-wrapper {
  max-width: 768px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}
.about-us-page .insight-section .insight-icon {
  font-size: 48px !important;
  color: #5ea1d8 !important;
  margin-bottom: 24px !important;
  opacity: 1 !important;
  visibility: visible !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.about-us-page .insight-section .insight-icon mat-icon {
  font-size: 48px !important;
  width: 48px !important;
  height: 48px !important;
  color: #5ea1d8 !important;
}
.about-us-page .insight-section .insight-title {
  font-size: 48px;
  font-weight: 700;
  line-height: 1.2;
  color: #ffffff !important;
  margin-bottom: 32px;
  letter-spacing: -0.02em;
  opacity: 1 !important;
  visibility: visible !important;
}
.about-us-page .insight-section .insight-title b {
  font-weight: 700;
  color: #ffffff !important;
}
@media (max-width: 768px) {
  .about-us-page .insight-section .insight-title {
    font-size: 32px;
  }
}
.about-us-page .insight-section .insight-description {
  font-size: 20px;
  line-height: 1.8;
  color: #94a3b8 !important;
  font-weight: 400;
  opacity: 1 !important;
  visibility: visible !important;
}
.about-us-page .insight-section .insight-description p {
  margin: 0;
  color: #94a3b8 !important;
}
.about-us-page .what-section {
  background: rgba(0, 0, 0, 0.4) !important;
  padding: 96px 24px !important;
  visibility: visible !important;
}
.about-us-page .what-section .section-label {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #5ea1d8 !important;
  text-align: center;
  margin-bottom: 64px;
  opacity: 1 !important;
  visibility: visible !important;
}
.about-us-page .what-section .feature-cards-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  margin-bottom: 96px;
}
@media (max-width: 992px) {
  .about-us-page .what-section .feature-cards-grid {
    grid-template-columns: 1fr;
  }
}
.about-us-page .what-section .feature-card {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  padding: 32px !important;
  border-radius: 16px !important;
  transition: all 0.3s ease !important;
}
.about-us-page .what-section .feature-card:hover {
  border-color: rgba(94, 161, 216, 0.5) !important;
  background: rgba(255, 255, 255, 0.08) !important;
}
.about-us-page .what-section .feature-card .card-icon {
  width: 48px !important;
  height: 48px !important;
  background: rgba(94, 161, 216, 0.2) !important;
  border-radius: 8px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin-bottom: 24px !important;
  font-size: 24px !important;
  transition: transform 0.3s ease !important;
}
.about-us-page .what-section .feature-card .card-icon mat-icon {
  font-size: 28px !important;
  width: 28px !important;
  height: 28px !important;
  color: #5ea1d8 !important;
}
.about-us-page .what-section .feature-card:hover .card-icon {
  transform: scale(1.1);
}
.about-us-page .what-section .feature-card .card-title {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 16px;
  color: #ffffff !important;
  opacity: 1 !important;
  visibility: visible !important;
}
.about-us-page .what-section .feature-card .card-copy {
  font-size: 16px;
  line-height: 1.7;
  color: #94a3b8 !important;
  font-weight: 400;
  opacity: 1 !important;
  visibility: visible !important;
}
.about-us-page .what-section .protocol-heading {
  font-size: 30px !important;
  font-weight: 700 !important;
  margin-bottom: 64px !important;
  color: #ffffff !important;
  text-align: left !important;
  margin-top: 0 !important;
  opacity: 1 !important;
  visibility: visible !important;
}
.about-us-page .what-section .steps-container {
  display: flex;
  flex-direction: row;
  gap: 32px;
  position: relative;
}
@media (max-width: 992px) {
  .about-us-page .what-section .steps-container {
    flex-direction: column;
  }
}
.about-us-page .what-section .steps-microline {
  font-size: 16px !important;
  font-weight: 400 !important;
  line-height: 1.6 !important;
  color: #64748b !important;
  text-align: center !important;
  margin-top: 48px !important;
  margin-bottom: 0 !important;
  opacity: 1 !important;
  visibility: visible !important;
}
.about-us-page .what-section .step-card {
  flex: 1;
  position: relative;
  padding-top: 60px !important;
  padding-left: 0 !important;
  padding-right: 16px !important;
}
.about-us-page .what-section .step-card .step-number-wrapper {
  position: relative !important;
  margin-bottom: 24px !important;
  height: 40px !important;
}
.about-us-page .what-section .step-card .step-number {
  font-size: 72px !important;
  font-weight: 700 !important;
  color: rgba(255, 255, 255, 0.1) !important;
  position: absolute !important;
  top: -60px !important;
  left: 0 !important;
  line-height: 1 !important;
  opacity: 1 !important;
  visibility: visible !important;
  z-index: 0 !important;
  pointer-events: none !important;
}
.about-us-page .what-section .step-card .step-content {
  position: relative !important;
  z-index: 1 !important;
  margin-top: 0 !important;
}
.about-us-page .what-section .step-card .step-content .step-title {
  font-size: 20px !important;
  font-weight: 700 !important;
  margin-bottom: 8px !important;
  margin-top: 0 !important;
  color: #ffffff !important;
  opacity: 1 !important;
  visibility: visible !important;
  position: relative !important;
  z-index: 2 !important;
}
.about-us-page .what-section .step-card .step-content .step-description {
  font-size: 16px !important;
  line-height: 1.7 !important;
  color: #94a3b8 !important;
  font-weight: 400 !important;
  opacity: 1 !important;
  visibility: visible !important;
  position: relative !important;
  z-index: 2 !important;
}
.about-us-page .what-section .step-card:nth-child(n+2) .step-content .step-description {
  padding-left: 0 !important;
  text-indent: 0 !important;
  position: relative !important;
}
.about-us-page .what-section .step-card:nth-child(n+2) .step-content .step-description::before {
  content: ">" !important;
  position: absolute !important;
  left: -20px !important;
  top: 0 !important;
  color: #5ea1d8 !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  opacity: 1 !important;
  visibility: visible !important;
  line-height: 1.7 !important;
}
.about-us-page .who-section {
  background: #0a0c10 !important;
  border-top: 1px solid rgba(255, 255, 255, 0.05) !important;
  padding: 96px 24px !important;
  visibility: visible !important;
}
.about-us-page .who-section .section-heading {
  font-size: 32px !important;
  font-weight: 700 !important;
  margin-bottom: 48px !important;
  text-align: center !important;
  color: #ffffff !important;
  opacity: 1 !important;
  visibility: visible !important;
}
.about-us-page .who-section .who-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}
@media (max-width: 992px) {
  .about-us-page .who-section .who-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 768px) {
  .about-us-page .who-section .who-grid {
    grid-template-columns: 1fr;
  }
}
.about-us-page .who-section .who-card {
  background: transparent !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  padding: 24px !important;
  border-radius: 12px !important;
  text-align: center !important;
  transition: all 0.3s ease !important;
}
.about-us-page .who-section .who-card:hover {
  background: rgba(255, 255, 255, 0.05) !important;
  border-color: rgba(255, 255, 255, 0.15) !important;
}
.about-us-page .who-section .who-card .who-icon {
  font-size: 32px;
  margin-bottom: 16px;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.about-us-page .who-section .who-card .who-icon mat-icon {
  font-size: 40px !important;
  width: 40px !important;
  height: 40px !important;
  color: #5ea1d8 !important;
}
.about-us-page .who-section .who-card .who-title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 8px;
  color: #ffffff !important;
  opacity: 1 !important;
  visibility: visible !important;
}
.about-us-page .who-section .who-card .who-copy {
  font-size: 14px;
  line-height: 1.6;
  color: #94a3b8 !important;
  font-weight: 400;
  opacity: 1 !important;
  visibility: visible !important;
}
.about-us-page .why-section {
  background: rgba(15, 23, 42, 0.2) !important;
  padding: 96px 24px !important;
  visibility: visible !important;
}
.about-us-page .why-section .section-heading {
  font-size: 32px !important;
  font-weight: 700 !important;
  margin-bottom: 48px !important;
  text-align: center !important;
  color: #ffffff !important;
  opacity: 1 !important;
  visibility: visible !important;
}
.about-us-page .why-section .comparison-table {
  max-width: 1000px;
  margin: 0 auto;
  background: rgba(0, 0, 0, 0.4) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-radius: 16px;
  overflow: hidden;
}
.about-us-page .why-section .comparison-header,
.about-us-page .why-section .comparison-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 1px;
  background: transparent;
}
.about-us-page .why-section .comparison-header {
  background: transparent;
}
.about-us-page .why-section .comparison-header .comparison-col-header {
  padding: 24px;
  font-weight: 700;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #94a3b8 !important;
  text-align: left;
  opacity: 1 !important;
  visibility: visible !important;
}
.about-us-page .why-section .comparison-header .comparison-col-header:last-child {
  color: #5ea1d8 !important;
}
.about-us-page .why-section .comparison-row {
  background: transparent;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}
.about-us-page .why-section .comparison-row .comparison-label {
  padding: 24px;
  font-weight: 500;
  color: #ffffff !important;
  font-size: 16px;
  opacity: 1 !important;
  visibility: visible !important;
}
.about-us-page .why-section .comparison-row .comparison-cell {
  padding: 24px;
  text-align: left;
  color: #94a3b8 !important;
  font-style: italic;
  font-size: 16px;
  opacity: 1 !important;
  visibility: visible !important;
}
.about-us-page .why-section .comparison-row .comparison-cell.highlight {
  color: #5ea1d8 !important;
  font-weight: 700;
  font-style: normal;
}
.about-us-page .founder-section {
  background: #0a0c10 !important;
  border-top: 1px solid rgba(255, 255, 255, 0.05) !important;
  padding: 96px 24px !important;
  visibility: visible !important;
}
.about-us-page .founder-section .founder-content-wrapper {
  max-width: 1400px !important;
  margin: 0 auto !important;
  display: grid !important;
  grid-template-columns: 400px 1fr !important;
  gap: 80px !important;
  align-items: flex-start !important;
}
@media (max-width: 992px) {
  .about-us-page .founder-section .founder-content-wrapper {
    grid-template-columns: 1fr !important;
    gap: 48px !important;
  }
}
.about-us-page .founder-section .founder-image-container {
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  justify-content: flex-start !important;
  margin: 0 !important;
  padding: 0 !important;
}
.about-us-page .founder-section .founder-image-container .founder-image {
  width: 100% !important;
  max-width: 400px !important;
  aspect-ratio: 3/4 !important;
  border-radius: 12px !important;
  overflow: hidden !important;
  filter: grayscale(100%) !important;
  transition: filter 0.5s ease !important;
  background: #4a5568 !important;
  background-image: url('founder.png') !important;
  background-size: cover !important;
  background-position: center !important;
  flex-shrink: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4) !important;
}
.about-us-page .founder-section .founder-image-container .founder-image:hover {
  filter: grayscale(0%) !important;
}
@media (max-width: 992px) {
  .about-us-page .founder-section .founder-image-container .founder-image {
    max-width: 100% !important;
    aspect-ratio: 3/4 !important;
  }
}
.about-us-page .founder-section .founder-image-container .founder-label {
  font-family: "Open Sans", sans-serif !important;
  font-size: 24px !important;
  font-weight: 700 !important;
  color: #ffffff !important;
  margin-top: 24px !important;
  margin-bottom: 8px !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding: 0 !important;
  opacity: 1 !important;
  visibility: visible !important;
  line-height: 1.2 !important;
}
.about-us-page .founder-section .founder-image-container .founder-name {
  font-family: "Open Sans", sans-serif !important;
  font-size: 16px !important;
  color: rgba(255, 255, 255, 0.7) !important;
  margin: 0 !important;
  padding: 0 !important;
  opacity: 1 !important;
  visibility: visible !important;
  line-height: 1.5 !important;
}
.about-us-page .founder-section .founder-text-container {
  display: flex !important;
  flex-direction: column !important;
  justify-content: flex-start !important;
  align-items: flex-start !important;
  margin: 0 !important;
  padding: 0 !important;
}
.about-us-page .founder-section .founder-text-container .founder-quote-block {
  margin: 2px 0 !important;
  margin-bottom: 16px !important;
  padding: 10px !important;
  background: rgba(30, 41, 59, 0.5) !important;
  border-left: 4px solid #5ea1d8 !important;
  border-radius: 0 12px 12px 0 !important;
  opacity: 1 !important;
  visibility: visible !important;
  width: 100% !important;
}
.about-us-page .founder-section .founder-text-container .founder-quote-block p {
  font-size: 15px !important;
  font-weight: 400 !important;
  font-style: italic !important;
  color: #ffffff !important;
  margin: 0 !important;
  line-height: 1.8 !important;
  opacity: 1 !important;
  visibility: visible !important;
}
.about-us-page .founder-section .founder-text-container .founder-heading {
  font-family: "Open Sans", sans-serif !important;
  font-size: 24px !important;
  font-weight: 700 !important;
  color: #ffffff !important;
  margin-bottom: 16px !important;
  margin-top: 0 !important;
  opacity: 1 !important;
  visibility: visible !important;
}
@media (max-width: 768px) {
  .about-us-page .founder-section .founder-text-container .founder-heading {
    font-size: 20px !important;
  }
}
.about-us-page .founder-section .founder-text-container .founder-text {
  font-family: "Open Sans", sans-serif !important;
  font-size: 16px !important;
  line-height: 1.75 !important;
  margin-bottom: 16px !important;
  margin-top: 0 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding: 0 !important;
  font-weight: 400 !important;
  color: rgba(255, 255, 255, 0.9) !important;
  opacity: 1 !important;
  visibility: visible !important;
}
.about-us-page .founder-section .founder-text-container .founder-text:last-of-type {
  margin-bottom: 16px !important;
}
.about-us-page .founder-section .founder-text-container .founder-text strong {
  font-family: "Open Sans", sans-serif !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  font-style: italic !important;
  color: #ffffff !important;
}
.about-us-page .founder-section .founder-text-container .founder-quote {
  font-family: "Open Sans", sans-serif !important;
  font-size: 18px !important;
  font-style: italic !important;
  font-weight: 400 !important;
  color: rgba(255, 255, 255, 0.9) !important;
  margin-top: 0 !important;
  padding-top: 0 !important;
  border-top: none !important;
  opacity: 1 !important;
  visibility: visible !important;
}
.about-us-page .vision-section {
  background: rgba(94, 161, 216, 0.05) !important;
  padding: 96px 24px !important;
  text-align: center;
  visibility: visible !important;
}
.about-us-page .vision-section .section-label {
  font-size: 12px !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.1em !important;
  color: #5ea1d8 !important;
  margin-bottom: 32px !important;
  opacity: 1 !important;
  visibility: visible !important;
}
.about-us-page .vision-section .section-heading {
  font-size: 32px !important;
  font-weight: 500 !important;
  line-height: 1.6 !important;
  margin-bottom: 48px !important;
  color: #ffffff !important;
  max-width: 900px !important;
  margin-left: auto !important;
  margin-right: auto !important;
  opacity: 1 !important;
  visibility: visible !important;
}
@media (max-width: 768px) {
  .about-us-page .vision-section .section-heading {
    font-size: 24px !important;
  }
}
.about-us-page .vision-section .vision-content {
  opacity: 1 !important;
  visibility: visible !important;
}
.about-us-page .vision-section .vision-text {
  font-size: 16px !important;
  line-height: 1.75 !important;
  color: rgba(255, 255, 255, 0.9) !important;
  margin-bottom: 32px !important;
  max-width: 800px !important;
  margin-left: auto !important;
  margin-right: auto !important;
  text-align: center !important;
  opacity: 1 !important;
  visibility: visible !important;
}
.about-us-page .vision-section .vision-quote {
  max-width: 672px !important;
  margin: 0 auto !important;
  padding-top: 32px !important;
  border-top: 1px solid rgba(255, 255, 255, 0.1) !important;
  font-style: italic !important;
  color: #94a3b8 !important;
  font-size: 18px !important;
  opacity: 1 !important;
  visibility: visible !important;
  line-height: 1.8;
  opacity: 1 !important;
  visibility: visible !important;
}
.about-us-page .vision-section .vision-quote p {
  color: #94a3b8 !important;
  opacity: 1 !important;
  visibility: visible !important;
}
.about-us-page .values-section {
  background: #0a0c10 !important;
  padding: 96px 24px !important;
  visibility: visible !important;
}
.about-us-page .values-section .section-heading {
  text-align: center !important;
  margin-bottom: 64px !important;
  color: #ffffff !important;
  font-size: 32px !important;
  font-weight: 700 !important;
}
.about-us-page .values-section .values-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 48px;
  max-width: 1400px;
  margin: 0 auto;
}
@media (max-width: 1200px) {
  .about-us-page .values-section .values-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 992px) {
  .about-us-page .values-section .values-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 768px) {
  .about-us-page .values-section .values-grid {
    grid-template-columns: 1fr;
  }
}
.about-us-page .values-section .value-item {
  text-align: center;
}
.about-us-page .values-section .value-item .value-icon-large {
  font-size: 48px;
  color: #5ea1d8;
  margin-bottom: 16px;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.about-us-page .values-section .value-item .value-icon-large mat-icon {
  font-size: 48px !important;
  width: 48px !important;
  height: 48px !important;
  color: #5ea1d8 !important;
}
.about-us-page .values-section .value-item .value-title {
  font-size: 18px;
  font-weight: 700;
  color: #ffffff !important;
  margin: 0;
  opacity: 1 !important;
  visibility: visible !important;
}
.about-us-page .closing-section {
  background: #0a0c10 !important;
  border-top: 1px solid rgba(255, 255, 255, 0.05) !important;
  padding: 128px 24px !important;
  text-align: center;
  position: relative;
  overflow: hidden;
  visibility: visible !important;
}
.about-us-page .closing-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 800px;
  height: 400px;
  background: rgba(94, 161, 216, 0.2);
  filter: blur(120px);
  border-radius: 50%;
  z-index: 0;
  pointer-events: none;
}
.about-us-page .closing-section .closing-content {
  max-width: 900px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}
.about-us-page .closing-section .closing-intro {
  font-size: 20px;
  font-weight: 400;
  font-style: italic !important;
  line-height: 1.8;
  color: #94a3b8 !important;
  margin-bottom: 32px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  opacity: 1 !important;
  visibility: visible !important;
}
@media (max-width: 768px) {
  .about-us-page .closing-section .closing-intro {
    font-size: 18px;
  }
}
.about-us-page .closing-section .closing-statement {
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 16px;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: #ffffff !important;
  opacity: 1 !important;
  visibility: visible !important;
}
@media (max-width: 768px) {
  .about-us-page .closing-section .closing-statement {
    font-size: 32px;
  }
}
.about-us-page .closing-section .closing-subtext {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.7) !important;
  margin-bottom: 40px;
  opacity: 1 !important;
  visibility: visible !important;
}
@media (max-width: 768px) {
  .about-us-page .closing-section .closing-subtext {
    font-size: 14px;
  }
}
.about-us-page .closing-section .cta-buttons {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}
.about-us-page .closing-section .btn-primary,
.about-us-page .closing-section .btn-secondary {
  font-family: "Open Sans", sans-serif !important;
  padding: 18px 40px;
  font-size: 18px;
  font-weight: 700;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  height: 56px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.about-us-page .closing-section .btn-primary {
  background: #5ea1d8;
  color: #ffffff;
  box-shadow: 0 10px 25px rgba(94, 161, 216, 0.25);
}
.about-us-page .closing-section .btn-primary:hover {
  background: rgba(94, 161, 216, 0.9);
  transform: translateY(-2px);
  box-shadow: 0 15px 35px rgba(94, 161, 216, 0.35);
}
.about-us-page .closing-section .btn-secondary {
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.about-us-page .closing-section .btn-secondary:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}
.about-us-page .footer {
  background: #000000;
  color: #ffffff;
  padding: 14px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}
.about-us-page .footer .copy-rights {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
  width: 100%;
}
.about-us-page .footer .copy-rights .row {
  display: flex;
  align-items: center;
  margin: 0;
  width: 100%;
}
@media (max-width: 768px) {
  .about-us-page .footer .copy-rights .row {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
}
.about-us-page .footer .copy-rights .col-md-5,
.about-us-page .footer .copy-rights .col-md-7,
.about-us-page .footer .copy-rights .col-12 {
  padding: 0;
  display: flex;
  align-items: center;
}
@media (max-width: 768px) {
  .about-us-page .footer .copy-rights .col-md-5,
  .about-us-page .footer .copy-rights .col-md-7,
  .about-us-page .footer .copy-rights .col-12 {
    width: 100%;
    justify-content: flex-start;
  }
}
@media (min-width: 769px) {
  .about-us-page .footer .copy-rights .col-md-5 {
    justify-content: flex-start;
  }
}
@media (min-width: 769px) {
  .about-us-page .footer .copy-rights .col-md-7 {
    justify-content: flex-end;
  }
}
.about-us-page .footer .cpyrgt {
  color: #64748b !important;
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 1.5;
  width: 100%;
}
@media (max-width: 768px) {
  .about-us-page .footer .cpyrgt {
    flex-wrap: wrap;
  }
}
.about-us-page .footer .cpyrgt li {
  color: #64748b !important;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.about-us-page .footer .cpyrgt li a {
  color: #64748b !important;
  text-decoration: none;
  margin-left: 4px;
}
.about-us-page .footer .cpyrgt li a:hover {
  color: #5ea1d8 !important;
  text-decoration: underline;
}
.about-us-page .footer .f-menu-right {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 0;
  width: 100%;
}
@media (max-width: 768px) {
  .about-us-page .footer .f-menu-right {
    justify-content: flex-start;
    flex-wrap: wrap;
  }
}
.about-us-page .footer .f-menu-right li {
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
}
.about-us-page .footer .f-menu-right li:not(:last-child)::after {
  content: "|";
  color: rgba(100, 116, 139, 0.5);
  margin: 0 12px;
  font-size: 14px;
}
.about-us-page .footer .f-menu-right li a {
  color: #64748b !important;
  font-size: 14px;
  text-decoration: none;
  transition: color 0.3s ease;
  padding: 4px 0;
  white-space: nowrap;
}
.about-us-page .footer .f-menu-right li a:hover {
  color: #5ea1d8 !important;
}
.about-us-page .footer h6 {
  color: #94a3b8 !important;
  font-weight: 700 !important;
  font-size: 12px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.1em !important;
  margin-bottom: 16px !important;
}
.about-us-page .footer ul li a {
  color: #64748b !important;
  font-size: 14px !important;
}
.about-us-page .footer ul li a:hover {
  color: #5ea1d8 !important;
}
.about-us-page .footer p {
  color: #475569 !important;
  font-size: 14px !important;
}
.about-us-page .footer .material-symbols-outlined {
  color: #475569 !important;
}
.about-us-page .footer .material-symbols-outlined:hover {
  color: #ffffff !important;
}
@media (max-width: 768px) {
  .about-us-page .container {
    padding: 0 24px !important;
  }
  .about-us-page .section {
    padding: 60px 24px !important;
  }
  .about-us-page .cta-buttons {
    flex-direction: column;
  }
  .about-us-page .cta-buttons .btn-primary,
  .about-us-page .cta-buttons .btn-secondary {
    width: 100%;
  }
}

@media screen and (max-width: 992px) {
  :host footer,
  :host .footer,
  app-about-us footer,
  app-about-us .footer {
    display: block !important;
    visibility: visible !important;
  }
}
body.theme-light .about-us-page {
  background: #f8fafc !important;
  color: #0f172a !important;
}
body.theme-light .about-us-page .page-header {
  background: rgba(255, 255, 255, 0.95) !important;
  border-bottom-color: rgba(0, 0, 0, 0.08) !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08) !important;
  -webkit-backdrop-filter: blur(20px) !important;
          backdrop-filter: blur(20px) !important;
}
body.theme-light .about-us-page .page-header.scrolled {
  background: rgba(255, 255, 255, 0.98) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}
body.theme-light .about-us-page .page-header .menu-button {
  color: #0f172a !important;
}
body.theme-light .about-us-page .page-header .menu-button:hover {
  background-color: rgba(0, 0, 0, 0.06) !important;
}
body.theme-light .about-us-page .page-header .header-nav .nav-link {
  color: rgba(15, 23, 42, 0.5) !important;
}
body.theme-light .about-us-page .page-header .header-nav .nav-link:hover {
  color: #0f172a !important;
}
body.theme-light .about-us-page .page-header .btn-get-started {
  background: #5ea1d8 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
}
body.theme-light .about-us-page .page-header .btn-get-started:hover {
  background: #4a8cc5 !important;
  box-shadow: 0 4px 12px rgba(94, 161, 216, 0.35) !important;
}
body.theme-light .about-us-page .hero-section {
  background: linear-gradient(160deg, #90c3e8 0%, #70aedf 55%, #5ea1d8 100%) !important;
  color: #ffffff !important;
}
body.theme-light .about-us-page .hero-section::before {
  background-image: radial-gradient(circle at 1px 1px, rgba(255, 255, 255, 0.12) 1px, transparent 0) !important;
}
body.theme-light .about-us-page .hero-section::after {
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.06), transparent) !important;
}
body.theme-light .about-us-page .hero-section .hero-badge {
  background: rgba(255, 255, 255, 0.15) !important;
  color: #ffffff !important;
  border-color: rgba(255, 255, 255, 0.35) !important;
}
body.theme-light .about-us-page .hero-section .hero-title {
  background: linear-gradient(to right, #ffffff, rgba(255, 255, 255, 0.85)) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  background-clip: text !important;
}
body.theme-light .about-us-page .hero-section .hero-subheading {
  color: rgba(255, 255, 255, 0.88) !important;
}
body.theme-light .about-us-page .hero-section .hero-microline {
  color: rgba(255, 255, 255, 0.7) !important;
}
body.theme-light .about-us-page .problem-section {
  background: #ffffff !important;
  border-top-color: rgba(94, 161, 216, 0.15) !important;
  border-bottom-color: rgba(94, 161, 216, 0.15) !important;
}
body.theme-light .about-us-page .problem-section .section-heading {
  color: #0f172a !important;
}
body.theme-light .about-us-page .problem-section .body-copy {
  color: #475569 !important;
}
body.theme-light .about-us-page .problem-section .pull-quote {
  background: rgba(94, 161, 216, 0.06) !important;
  border-left-color: #5ea1d8 !important;
}
body.theme-light .about-us-page .problem-section .pull-quote p {
  color: #0f172a !important;
}
body.theme-light .about-us-page .insight-section {
  background: linear-gradient(160deg, #90c3e8 0%, #70aedf 55%, #5ea1d8 100%) !important;
}
body.theme-light .about-us-page .insight-section::before {
  background-image: radial-gradient(circle at 1px 1px, rgba(255, 255, 255, 0.12) 1px, transparent 0) !important;
}
body.theme-light .about-us-page .insight-section::after {
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.06), transparent) !important;
}
body.theme-light .about-us-page .insight-section .insight-icon mat-icon {
  color: rgba(255, 255, 255, 0.9) !important;
}
body.theme-light .about-us-page .insight-section .insight-title {
  color: #ffffff !important;
}
body.theme-light .about-us-page .insight-section .insight-title b {
  color: #ffffff !important;
}
body.theme-light .about-us-page .insight-section .insight-description {
  color: rgba(255, 255, 255, 0.85) !important;
}
body.theme-light .about-us-page .insight-section .insight-description p {
  color: rgba(255, 255, 255, 0.85) !important;
}
body.theme-light .about-us-page .what-section {
  background: #f8fafc !important;
}
body.theme-light .about-us-page .what-section .section-label {
  color: #5ea1d8 !important;
}
body.theme-light .about-us-page .what-section .feature-card {
  background: #ffffff !important;
  border-color: rgba(94, 161, 216, 0.15) !important;
  box-shadow: 0 2px 8px rgba(94, 161, 216, 0.06) !important;
}
body.theme-light .about-us-page .what-section .feature-card:hover {
  border-color: rgba(94, 161, 216, 0.4) !important;
  background: #ffffff !important;
  box-shadow: 0 4px 16px rgba(94, 161, 216, 0.12) !important;
}
body.theme-light .about-us-page .what-section .feature-card .card-icon {
  background: rgba(94, 161, 216, 0.1) !important;
}
body.theme-light .about-us-page .what-section .feature-card .card-title {
  color: #0f172a !important;
}
body.theme-light .about-us-page .what-section .feature-card .card-copy {
  color: #64748b !important;
}
body.theme-light .about-us-page .what-section .protocol-heading {
  color: #0f172a !important;
}
body.theme-light .about-us-page .what-section .steps-microline {
  color: #94a3b8 !important;
}
body.theme-light .about-us-page .what-section .step-card .step-number {
  color: rgba(58, 122, 181, 0.35) !important;
}
body.theme-light .about-us-page .what-section .step-card .step-content .step-title {
  color: #0f172a !important;
}
body.theme-light .about-us-page .what-section .step-card .step-content .step-description {
  color: #64748b !important;
}
body.theme-light .about-us-page .who-section {
  background: #ffffff !important;
  border-top-color: rgba(94, 161, 216, 0.12) !important;
}
body.theme-light .about-us-page .who-section .section-heading {
  color: #0f172a !important;
}
body.theme-light .about-us-page .who-section .who-card {
  border-color: rgba(94, 161, 216, 0.15) !important;
}
body.theme-light .about-us-page .who-section .who-card:hover {
  background: rgba(94, 161, 216, 0.04) !important;
  border-color: rgba(94, 161, 216, 0.3) !important;
}
body.theme-light .about-us-page .who-section .who-card .who-title {
  color: #0f172a !important;
}
body.theme-light .about-us-page .who-section .who-card .who-copy {
  color: #64748b !important;
}
body.theme-light .about-us-page .why-section {
  background: #f8fafc !important;
}
body.theme-light .about-us-page .why-section .section-heading {
  color: #0f172a !important;
}
body.theme-light .about-us-page .why-section .comparison-table {
  background: #ffffff !important;
  border-color: rgba(94, 161, 216, 0.2) !important;
  box-shadow: 0 2px 12px rgba(94, 161, 216, 0.08) !important;
}
body.theme-light .about-us-page .why-section .comparison-header .comparison-col-header {
  color: #64748b !important;
}
body.theme-light .about-us-page .why-section .comparison-header .comparison-col-header:last-child {
  color: #5ea1d8 !important;
}
body.theme-light .about-us-page .why-section .comparison-row {
  border-top-color: rgba(94, 161, 216, 0.1) !important;
}
body.theme-light .about-us-page .why-section .comparison-row .comparison-label {
  color: #0f172a !important;
}
body.theme-light .about-us-page .why-section .comparison-row .comparison-cell {
  color: #64748b !important;
}
body.theme-light .about-us-page .why-section .comparison-row .comparison-cell.highlight {
  color: #5ea1d8 !important;
}
body.theme-light .about-us-page .founder-section {
  background: #ffffff !important;
  border-top-color: rgba(94, 161, 216, 0.12) !important;
}
body.theme-light .about-us-page .founder-section .founder-label {
  color: #0f172a !important;
}
body.theme-light .about-us-page .founder-section .founder-name {
  color: #64748b !important;
}
body.theme-light .about-us-page .founder-section .founder-quote-block {
  background: rgba(94, 161, 216, 0.06) !important;
  border-left-color: #5ea1d8 !important;
}
body.theme-light .about-us-page .founder-section .founder-quote-block p {
  color: #0f172a !important;
}
body.theme-light .about-us-page .founder-section .founder-heading {
  color: #0f172a !important;
}
body.theme-light .about-us-page .founder-section .founder-text {
  color: #334155 !important;
}
body.theme-light .about-us-page .founder-section .founder-text strong {
  color: #0f172a !important;
}
body.theme-light .about-us-page .founder-section .founder-quote {
  color: #475569 !important;
}
body.theme-light .about-us-page .vision-section {
  background: rgba(94, 161, 216, 0.07) !important;
}
body.theme-light .about-us-page .vision-section .section-label {
  color: #5ea1d8 !important;
}
body.theme-light .about-us-page .vision-section .section-heading {
  color: #0f172a !important;
}
body.theme-light .about-us-page .vision-section .vision-text {
  color: #334155 !important;
}
body.theme-light .about-us-page .vision-section .vision-quote {
  border-top-color: rgba(94, 161, 216, 0.2) !important;
  color: #475569 !important;
}
body.theme-light .about-us-page .vision-section .vision-quote p {
  color: #475569 !important;
}
body.theme-light .about-us-page .values-section {
  background: #f8fafc !important;
}
body.theme-light .about-us-page .values-section .section-heading {
  color: #0f172a !important;
}
body.theme-light .about-us-page .values-section .value-title {
  color: #0f172a !important;
}
body.theme-light .about-us-page .closing-section {
  background: linear-gradient(160deg, #90c3e8 0%, #70aedf 55%, #5ea1d8 100%) !important;
  border-top: none !important;
}
body.theme-light .about-us-page .closing-section::before {
  background: rgba(255, 255, 255, 0.08) !important;
}
body.theme-light .about-us-page .closing-section .closing-intro {
  color: rgba(255, 255, 255, 0.82) !important;
}
body.theme-light .about-us-page .closing-section .closing-statement {
  color: #ffffff !important;
}
body.theme-light .about-us-page .closing-section .closing-subtext {
  color: rgba(255, 255, 255, 0.75) !important;
}
body.theme-light .about-us-page .closing-section .btn-primary {
  background: #ffffff !important;
  color: #5ea1d8 !important;
}
body.theme-light .about-us-page .closing-section .btn-primary:hover {
  background: rgba(255, 255, 255, 0.92) !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15) !important;
}
body.theme-light .about-us-page .closing-section .btn-secondary {
  background: rgba(255, 255, 255, 0.12) !important;
  color: #ffffff !important;
  border-color: rgba(255, 255, 255, 0.35) !important;
}
body.theme-light .about-us-page .closing-section .btn-secondary:hover {
  background: rgba(255, 255, 255, 0.22) !important;
  border-color: rgba(255, 255, 255, 0.55) !important;
}
body.theme-light .about-us-page .footer {
  background: #f1f5f9 !important;
  color: #475569 !important;
  border-top-color: rgba(0, 0, 0, 0.08) !important;
}
body.theme-light .about-us-page .footer .cpyrgt li,
body.theme-light .about-us-page .footer .cpyrgt li a,
body.theme-light .about-us-page .footer .f-menu-right li a {
  color: #64748b !important;
}
body.theme-light .about-us-page .footer .cpyrgt li a:hover,
body.theme-light .about-us-page .footer .f-menu-right li a:hover {
  color: #5ea1d8 !important;
}
body.theme-light .about-us-page .footer .material-symbols-outlined {
  color: #94a3b8 !important;
}
body.theme-light .about-us-page .footer .material-symbols-outlined:hover {
  color: #5ea1d8 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/about-us/about-us.component.scss"],"names":[],"mappings":"AACA;EACE,+CAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,wBAAA;AAAF;AAEE;EACE,wBAAA;EACA,yBAAA;AAAJ;AAIE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,WAAA;EACA,wBAAA;EACA,kDAAA;EACA,kCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,yBAAA;EACA,wCAAA;EA2LA,0FAAA;AA5LJ;AAII;EACE,wBAAA;AAFN;AAKI;EACE,yCAAA;EACA,kCAAA;AAHN;AAMI;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAJN;AAMM;EAVF;IAWI,eAAA;IACA,SAAA;IACA,YAAA;EAHN;AACF;AAMI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;AAJN;AAOI;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;EACA,cAAA;AALN;AAOM;EACE,0CAAA;AALR;AAQM;EACE,eAAA;EACA,WAAA;EACA,YAAA;AANR;AAUI;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AARN;AAUM;EACE,YAAA;EACA,WAAA;EACA,cAAA;AARR;AAWM;EACE;IACE,YAAA;EATR;AACF;AAaI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;AAXN;AAaM;EATF;IAUI,SAAA;EAVN;AACF;AAYM;EAbF;IAcI,aAAA;EATN;AACF;AAWM;EACE,oCAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,+BAAA;EACA,qBAAA;EACA,2BAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AATR;AAWQ;EACE,cAAA;AATV;AAcI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;AAZN;AAeI;EACE,oBAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AAbN;AAeM;EAGE,YAAA;EACA,aAAA;EACA,gBAAA;AAfR;AAkBM;EACE,uBAAA;AAhBR;AAoBI;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,sCAAA;AAlBN;AAqBI;EACE,mBAAA;AAnBN;AAsBI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,4EAAA;AApBN;AAuBI;EACE,2BAAA;EACA,cAAA;EACA,mBAAA;AArBN;AAwBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAtBN;AA0BI;EACE,yBAAA;AAxBN;AA2BI;EACE,yBAAA;AAzBN;AA4BI;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,wCAAA;EACA,cAAA;AA1BN;AA4BM;EACE,qCAAA;EACA,2BAAA;EACA,yCAAA;AA1BR;AA6BM;EArBF;IAsBI,iBAAA;IACA,eAAA;EA1BN;AACF;AA+BE;EACE,iBAAA;EACA,cAAA;EACA,0BAAA;AA7BJ;AA+BI;EALF;IAMI,0BAAA;EA5BJ;AACF;AAgCE;EACE,2BAAA;AA9BJ;AAkCE;EACE,2BAAA;AAhCJ;AAoCE;EACE,4BAAA;AAlCJ;AAsCE;EACE,2BAAA;AApCJ;AAwCE;EACE,2BAAA;AAtCJ;AA0CE;EACE,2BAAA;AAxCJ;AA4CE;EACE,4BAAA;AA1CJ;AA8CE;EACE,2BAAA;AA5CJ;AAgDE;EACE,6BAAA;EACA,kBAAA;EACA,8BAAA;EACA,qBAAA;AA9CJ;AAgDI;EANF;IAOI,6BAAA;EA7CJ;AACF;AAiDE;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,yBAAA;EACA,kBAAA;EACA,mCAAA;EACA,gBAAA;EACA,kBAAA;EAMA,gBAAA;EACA,8BAAA;EACA,qBAAA;AApDJ;AA8CI;EAZF;IAaI,kCAAA;IACA,gBAAA;EA3CJ;AACF;AAgDI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,kGAAA;EACA,0BAAA;EACA,oBAAA;AA9CN;AAiDI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,4EAAA;EACA,oBAAA;AA/CN;AAkDI;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;AAhDN;AAmDI;EACE,8CAAA;EACA,yBAAA;EACA,oDAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;EACA,gCAAA;EACA,oCAAA;EACA,gCAAA;EACA,8BAAA;EACA,gCAAA;EACA,qBAAA;EACA,8BAAA;AAjDN;AAoDI;EACE,+CAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6EAAA;EACA,wCAAA;EACA,+CAAA;EACA,gCAAA;EACA,qBAAA;EACA,8BAAA;AAlDN;AAoDM;EAdF;IAeI,eAAA;EAjDN;AACF;AAoDI;EACE,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,yBAAA;EACA,2BAAA;EACA,8BAAA;EACA,qBAAA;EACA,8BAAA;AAlDN;AAoDM;EAVF;IAWI,0BAAA;EAjDN;AACF;AAoDI;EACE,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,yBAAA;EACA,2BAAA;EACA,yBAAA;EACA,qBAAA;EACA,8BAAA;AAlDN;AAoDM;EAVF;IAWI,0BAAA;EAjDN;AACF;AAsDE;EACE,yCAAA;EACA,0DAAA;EACA,6DAAA;EACA,6BAAA;EACA,6BAAA;EACA,qBAAA;EACA,8BAAA;AApDJ;AAsDI;EACE,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,yBAAA;EACA,qBAAA;EACA,8BAAA;EACA,2BAAA;EACA,kCAAA;AApDN;AAsDM;EAVF;IAWI,0BAAA;EAnDN;AACF;AAsDI;EACE,2BAAA;EACA,yBAAA;AApDN;AAuDI;EACE,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,8BAAA;EACA,2BAAA;EACA,qBAAA;EACA,8BAAA;AArDN;AAwDI;EACE,yBAAA;EACA,wBAAA;EACA,4CAAA;EACA,yCAAA;EACA,uCAAA;EACA,qBAAA;EACA,8BAAA;AAtDN;AAwDM;EACE,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,yBAAA;EACA,oBAAA;EACA,2BAAA;EACA,qBAAA;EACA,8BAAA;AAtDR;AAwDQ;EAVF;IAWI,0BAAA;EArDR;AACF;AA2DE;EACE,8BAAA;EACA,kBAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,8BAAA;AAzDJ;AA2DI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,kGAAA;EACA,0BAAA;EACA,oBAAA;AAzDN;AA4DI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,4EAAA;EACA,oBAAA;AA1DN;AA6DI;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AA3DN;AA8DI;EACE,0BAAA;EACA,yBAAA;EACA,8BAAA;EACA,qBAAA;EACA,8BAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;AA5DN;AA8DM;EACE,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;AA5DR;AAgEI;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,8BAAA;AA9DN;AAgEM;EACE,gBAAA;EACA,yBAAA;AA9DR;AAiEM;EAfF;IAgBI,eAAA;EA9DN;AACF;AAiEI;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,qBAAA;EACA,8BAAA;AA/DN;AAiEM;EACE,SAAA;EACA,yBAAA;AA/DR;AAqEE;EACE,yCAAA;EACA,6BAAA;EACA,8BAAA;AAnEJ;AAqEI;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,8BAAA;AAnEN;AAsEI;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;AApEN;AAsEM;EANF;IAOI,0BAAA;EAnEN;AACF;AAsEI;EACE,gDAAA;EACA,qDAAA;EACA,wBAAA;EACA,8BAAA;EACA,oCAAA;AApEN;AAsEM;EACE,gDAAA;EACA,gDAAA;AApER;AAuEM;EACE,sBAAA;EACA,uBAAA;EACA,8CAAA;EACA,6BAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,8BAAA;EACA,0BAAA;EACA,0CAAA;AArER;AAuEQ;EACE,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;AArEV;AAyEM;EACE,qBAAA;AAvER;AA0EM;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,8BAAA;AAxER;AA2EM;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,qBAAA;EACA,8BAAA;AAzER;AA6EI;EACE,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,yBAAA;EACA,2BAAA;EACA,wBAAA;EACA,qBAAA;EACA,8BAAA;AA3EN;AA8EI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AA5EN;AA8EM;EANF;IAOI,sBAAA;EA3EN;AACF;AA8EI;EACE,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,yBAAA;EACA,6BAAA;EACA,2BAAA;EACA,2BAAA;EACA,qBAAA;EACA,8BAAA;AA5EN;AA+EI;EACE,OAAA;EACA,kBAAA;EACA,4BAAA;EACA,0BAAA;EACA,8BAAA;AA7EN;AA+EM;EACE,6BAAA;EACA,8BAAA;EACA,uBAAA;AA7ER;AAgFM;EACE,0BAAA;EACA,2BAAA;EACA,0CAAA;EACA,6BAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,8BAAA;EACA,qBAAA;EACA,+BAAA;AA9ER;AAiFM;EACE,6BAAA;EACA,qBAAA;EACA,wBAAA;AA/ER;AAiFQ;EACE,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wBAAA;EACA,yBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,qBAAA;AA/EV;AAkFQ;EACE,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,2BAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EACA,qBAAA;AAhFV;AAoFM;EACE,0BAAA;EACA,yBAAA;EACA,6BAAA;AAlFR;AAoFQ;EACE,uBAAA;EACA,6BAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;EACA,0BAAA;EACA,2BAAA;EACA,qBAAA;EACA,8BAAA;EACA,2BAAA;AAlFV;AAyFE;EACE,8BAAA;EACA,0DAAA;EACA,6BAAA;EACA,8BAAA;AAvFJ;AAyFI;EACE,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,6BAAA;EACA,yBAAA;EACA,qBAAA;EACA,8BAAA;AAvFN;AA0FI;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AAxFN;AA0FM;EALF;IAMI,qCAAA;EAvFN;AACF;AAyFM;EATF;IAUI,0BAAA;EAtFN;AACF;AAyFI;EACE,kCAAA;EACA,qDAAA;EACA,wBAAA;EACA,8BAAA;EACA,6BAAA;EACA,oCAAA;AAvFN;AAyFM;EACE,gDAAA;EACA,kDAAA;AAvFR;AA0FM;EACE,eAAA;EACA,mBAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;AAxFR;AA0FQ;EACE,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;AAxFV;AA4FM;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,8BAAA;AA1FR;AA6FM;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,qBAAA;EACA,8BAAA;AA3FR;AAiGE;EACE,4CAAA;EACA,6BAAA;EACA,8BAAA;AA/FJ;AAiGI;EACE,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,6BAAA;EACA,yBAAA;EACA,qBAAA;EACA,8BAAA;AA/FN;AAkGI;EACE,iBAAA;EACA,cAAA;EACA,yCAAA;EACA,qDAAA;EACA,mBAAA;EACA,gBAAA;AAhGN;AAmGI;;EAEE,aAAA;EACA,kCAAA;EACA,QAAA;EACA,uBAAA;AAjGN;AAoGI;EACE,uBAAA;AAlGN;AAoGM;EACE,aAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,qBAAA;EACA,8BAAA;AAlGR;AAoGQ;EACE,yBAAA;AAlGV;AAuGI;EACE,uBAAA;EACA,8CAAA;AArGN;AAuGM;EACE,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,qBAAA;EACA,8BAAA;AArGR;AAwGM;EACE,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,8BAAA;AAtGR;AAwGQ;EACE,yBAAA;EACA,gBAAA;EACA,kBAAA;AAtGV;AA6GE;EACE,8BAAA;EACA,0DAAA;EACA,6BAAA;EACA,8BAAA;AA3GJ;AA6GI;EACE,4BAAA;EACA,yBAAA;EACA,wBAAA;EACA,2CAAA;EACA,oBAAA;EACA,kCAAA;AA3GN;AA6GM;EARF;IASI,qCAAA;IACA,oBAAA;EA1GN;AACF;AA6GI;EACE,wBAAA;EACA,iCAAA;EACA,kCAAA;EACA,sCAAA;EACA,oBAAA;EACA,qBAAA;AA3GN;AA6GM;EACE,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,8BAAA;EACA,2BAAA;EACA,kCAAA;EACA,uCAAA;EACA,8BAAA;EACA,+CAAA;EACA,iCAAA;EACA,sCAAA;EACA,yBAAA;EACA,oBAAA;EACA,qBAAA;EACA,oDAAA;AA3GR;AA6GQ;EACE,gCAAA;AA3GV;AA8GQ;EArBF;IAsBI,0BAAA;IACA,4BAAA;EA3GR;AACF;AA8GM;EACE,+CAAA;EACA,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,2BAAA;EACA,6BAAA;EACA,yBAAA;EACA,0BAAA;EACA,qBAAA;EACA,qBAAA;EACA,8BAAA;EACA,2BAAA;AA5GR;AA+GM;EACE,+CAAA;EACA,0BAAA;EACA,0CAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,8BAAA;EACA,2BAAA;AA7GR;AAiHI;EACE,wBAAA;EACA,iCAAA;EACA,sCAAA;EACA,kCAAA;EACA,oBAAA;EACA,qBAAA;AA/GN;AAiHM;EACE,wBAAA;EACA,8BAAA;EACA,wBAAA;EACA,4CAAA;EACA,yCAAA;EACA,uCAAA;EACA,qBAAA;EACA,8BAAA;EACA,sBAAA;AA/GR;AAiHQ;EACE,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,yBAAA;EACA,oBAAA;EACA,2BAAA;EACA,qBAAA;EACA,8BAAA;AA/GV;AAmHM;EACE,+CAAA;EACA,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,8BAAA;EACA,wBAAA;EACA,qBAAA;EACA,8BAAA;AAjHR;AAmHQ;EAVF;IAWI,0BAAA;EAhHR;AACF;AAmHM;EACE,+CAAA;EACA,0BAAA;EACA,4BAAA;EACA,8BAAA;EACA,wBAAA;EACA,yBAAA;EACA,0BAAA;EACA,qBAAA;EACA,2BAAA;EACA,0CAAA;EACA,qBAAA;EACA,8BAAA;AAjHR;AAmHQ;EACE,8BAAA;AAjHV;AAoHQ;EACE,+CAAA;EACA,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,yBAAA;AAlHV;AAsHM;EACE,+CAAA;EACA,0BAAA;EACA,6BAAA;EACA,2BAAA;EACA,0CAAA;EACA,wBAAA;EACA,yBAAA;EACA,2BAAA;EACA,qBAAA;EACA,8BAAA;AApHR;AA0HE;EACE,+CAAA;EACA,6BAAA;EACA,kBAAA;EACA,8BAAA;AAxHJ;AA0HI;EACE,0BAAA;EACA,2BAAA;EACA,oCAAA;EACA,gCAAA;EACA,yBAAA;EACA,8BAAA;EACA,qBAAA;EACA,8BAAA;AAxHN;AA2HI;EACE,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,yBAAA;EACA,2BAAA;EACA,4BAAA;EACA,6BAAA;EACA,qBAAA;EACA,8BAAA;AAzHN;AA2HM;EAZF;IAaI,0BAAA;EAxHN;AACF;AA2HI;EACE,qBAAA;EACA,8BAAA;AAzHN;AA4HI;EACE,0BAAA;EACA,4BAAA;EACA,0CAAA;EACA,8BAAA;EACA,2BAAA;EACA,4BAAA;EACA,6BAAA;EACA,6BAAA;EACA,qBAAA;EACA,8BAAA;AA1HN;AA6HI;EACE,2BAAA;EACA,yBAAA;EACA,4BAAA;EACA,yDAAA;EACA,6BAAA;EACA,yBAAA;EACA,0BAAA;EACA,qBAAA;EACA,8BAAA;EAOA,gBAAA;EACA,qBAAA;EACA,8BAAA;AAjIN;AA0HM;EACE,yBAAA;EACA,qBAAA;EACA,8BAAA;AAxHR;AAiIE;EACE,8BAAA;EACA,6BAAA;EACA,8BAAA;AA/HJ;AAiII;EACE,6BAAA;EACA,8BAAA;EACA,yBAAA;EACA,0BAAA;EACA,2BAAA;AA/HN;AAkII;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;AAhIN;AAkIM;EAPF;IAQI,qCAAA;EA/HN;AACF;AAiIM;EAXF;IAYI,qCAAA;EA9HN;AACF;AAgIM;EAfF;IAgBI,0BAAA;EA7HN;AACF;AAgII;EACE,kBAAA;AA9HN;AAgIM;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;AA9HR;AAgIQ;EACE,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;AA9HV;AAkIM;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,SAAA;EACA,qBAAA;EACA,8BAAA;AAhIR;AAsIE;EACE,8BAAA;EACA,0DAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;AApIJ;AAsII;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,aAAA;EACA,mCAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;AApIN;AAuII;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AArIN;AAwII;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,8BAAA;AAtIN;AAwIM;EAbF;IAcI,eAAA;EArIN;AACF;AAwII;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;EACA,8BAAA;AAtIN;AAwIM;EAVF;IAWI,eAAA;EArIN;AACF;AAwII;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,0CAAA;EACA,mBAAA;EACA,qBAAA;EACA,8BAAA;AAtIN;AAwIM;EATF;IAUI,eAAA;EArIN;AACF;AAwII;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;AAtIN;AAyII;;EAEE,+CAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAvIN;AA0II;EACE,mBAAA;EACA,cAAA;EACA,gDAAA;AAxIN;AA0IM;EACE,mCAAA;EACA,2BAAA;EACA,gDAAA;AAxIR;AA4II;EACE,oCAAA;EACA,cAAA;EACA,0CAAA;AA1IN;AA4IM;EACE,oCAAA;EACA,sCAAA;EACA,2BAAA;AA1IR;AAgJE;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,+CAAA;AA9IJ;AAgJI;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;AA9IN;AAgJM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AA9IR;AAgJQ;EANF;IAOI,sBAAA;IACA,uBAAA;IACA,SAAA;EA7IR;AACF;AAgJM;;;EAGE,UAAA;EACA,aAAA;EACA,mBAAA;AA9IR;AAgJQ;EAPF;;;IAQI,WAAA;IACA,2BAAA;EA3IR;AACF;AA+IQ;EADF;IAEI,2BAAA;EA5IR;AACF;AAgJQ;EADF;IAEI,yBAAA;EA7IR;AACF;AAiJI;EACE,yBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AA/IN;AAiJM;EAXF;IAYI,eAAA;EA9IN;AACF;AAgJM;EACE,yBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AA9IR;AAgJQ;EACE,yBAAA;EACA,qBAAA;EACA,gBAAA;AA9IV;AAgJU;EACE,yBAAA;EACA,0BAAA;AA9IZ;AAoJI;EACE,aAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,MAAA;EACA,WAAA;AAlJN;AAoJM;EAXF;IAYI,2BAAA;IACA,eAAA;EAjJN;AACF;AAmJM;EACE,UAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;AAjJR;AAmJQ;EACE,YAAA;EACA,+BAAA;EACA,cAAA;EACA,eAAA;AAjJV;AAoJQ;EACE,yBAAA;EACA,eAAA;EACA,qBAAA;EACA,2BAAA;EACA,cAAA;EACA,mBAAA;AAlJV;AAoJU;EACE,yBAAA;AAlJZ;AAwJI;EACE,yBAAA;EACA,2BAAA;EACA,0BAAA;EACA,oCAAA;EACA,gCAAA;EACA,8BAAA;AAtJN;AA2JQ;EACE,yBAAA;EACA,0BAAA;AAzJV;AA2JU;EACE,yBAAA;AAzJZ;AA+JI;EACE,yBAAA;EACA,0BAAA;AA7JN;AAgKI;EACE,yBAAA;AA9JN;AAgKM;EACE,yBAAA;AA9JR;AAoKE;EACE;IACE,0BAAA;EAlKJ;EAqKE;IACE,6BAAA;EAnKJ;EAsKE;IACE,sBAAA;EApKJ;EAsKI;;IAEE,WAAA;EApKN;AACF;;AA0KA;EACE;;;;IAIE,yBAAA;IACA,8BAAA;EAvKF;AACF;AA+KE;EACE,8BAAA;EACA,yBAAA;AA7KJ;AAgLI;EACE,gDAAA;EACA,mDAAA;EACA,oDAAA;EACA,8CAAA;UAAA,sCAAA;AA9KN;AAgLM;EACE,gDAAA;EACA,oDAAA;AA9KR;AAiLM;EACE,yBAAA;AA/KR;AAgLQ;EAAU,gDAAA;AA7KlB;AAgLM;EACE,uCAAA;AA9KR;AA+KQ;EAAU,yBAAA;AA5KlB;AA+KM;EACE,8BAAA;EACA,yBAAA;EACA,2BAAA;AA7KR;AA8KQ;EACE,8BAAA;EACA,0DAAA;AA5KV;AAkLI;EACE,qFAAA;EACA,yBAAA;AAhLN;AAkLM;EACE,6GAAA;AAhLR;AAmLM;EACE,yFAAA;AAjLR;AAoLM;EACE,gDAAA;EACA,yBAAA;EACA,kDAAA;AAlLR;AAqLM;EACE,oFAAA;EACA,wCAAA;EACA,+CAAA;EACA,gCAAA;AAnLR;AAsLM;EAAmB,2CAAA;AAnLzB;AAoLM;EAAmB,0CAAA;AAjLzB;AAqLI;EACE,8BAAA;EACA,qDAAA;EACA,wDAAA;AAnLN;AAqLM;EAAmB,yBAAA;AAlLzB;AAmLM;EAAmB,yBAAA;AAhLzB;AAkLM;EACE,+CAAA;EACA,qCAAA;AAhLR;AAiLQ;EAAI,yBAAA;AA9KZ;AAmLI;EACE,qFAAA;AAjLN;AAmLM;EACE,6GAAA;AAjLR;AAoLM;EACE,yFAAA;AAlLR;AAqLM;EAAyB,0CAAA;AAlL/B;AAoLM;EACE,yBAAA;AAlLR;AAmLQ;EAAI,yBAAA;AAhLZ;AAmLM;EACE,2CAAA;AAjLR;AAkLQ;EAAI,2CAAA;AA/KZ;AAoLI;EACE,8BAAA;AAlLN;AAoLM;EAAiB,yBAAA;AAjLvB;AAmLM;EACE,8BAAA;EACA,iDAAA;EACA,yDAAA;AAjLR;AAmLQ;EACE,gDAAA;EACA,8BAAA;EACA,0DAAA;AAjLV;AAoLQ;EAAa,8CAAA;AAjLrB;AAkLQ;EAAc,yBAAA;AA/KtB;AAgLQ;EAAc,yBAAA;AA7KtB;AAgLM;EAAoB,yBAAA;AA7K1B;AA8KM;EAAoB,yBAAA;AA3K1B;AA8KQ;EAAe,0CAAA;AA3KvB;AA8KU;EAAoB,yBAAA;AA3K9B;AA4KU;EAAoB,yBAAA;AAzK9B;AA+KI;EACE,8BAAA;EACA,qDAAA;AA7KN;AA+KM;EAAmB,yBAAA;AA5KzB;AA8KM;EACE,iDAAA;AA5KR;AA8KQ;EACE,+CAAA;EACA,gDAAA;AA5KV;AA+KQ;EAAa,yBAAA;AA5KrB;AA6KQ;EAAa,yBAAA;AA1KrB;AA+KI;EACE,8BAAA;AA7KN;AA+KM;EAAmB,yBAAA;AA5KzB;AA8KM;EACE,8BAAA;EACA,gDAAA;EACA,0DAAA;AA5KR;AA+KM;EACE,yBAAA;AA7KR;AA8KQ;EAAe,yBAAA;AA3KvB;AA8KM;EACE,oDAAA;AA5KR;AA8KQ;EAAoB,yBAAA;AA3K5B;AA6KQ;EACE,yBAAA;AA3KV;AA4KU;EAAc,yBAAA;AAzKxB;AA+KI;EACE,8BAAA;EACA,qDAAA;AA7KN;AA+KM;EAAiB,yBAAA;AA5KvB;AA6KM;EAAiB,yBAAA;AA1KvB;AA4KM;EACE,+CAAA;EACA,qCAAA;AA1KR;AA2KQ;EAAI,yBAAA;AAxKZ;AA2KM;EAAmB,yBAAA;AAxKzB;AAyKM;EACE,yBAAA;AAvKR;AAwKQ;EAAS,yBAAA;AArKjB;AAuKM;EAAiB,yBAAA;AApKvB;AAwKI;EACE,+CAAA;AAtKN;AAwKM;EAAoB,yBAAA;AArK1B;AAsKM;EAAoB,yBAAA;AAnK1B;AAoKM;EAAoB,yBAAA;AAjK1B;AAmKM;EACE,oDAAA;EACA,yBAAA;AAjKR;AAkKQ;EAAI,yBAAA;AA/JZ;AAoKI;EACE,8BAAA;AAlKN;AAoKM;EAAmB,yBAAA;AAjKzB;AAkKM;EAAmB,yBAAA;AA/JzB;AAmKI;EACE,qFAAA;EACA,2BAAA;AAjKN;AAmKM;EACE,gDAAA;AAjKR;AAoKM;EAAqB,2CAAA;AAjK3B;AAkKM;EAAqB,yBAAA;AA/J3B;AAgKM;EAAqB,2CAAA;AA7J3B;AA+JM;EACE,8BAAA;EACA,yBAAA;AA7JR;AA8JQ;EACE,gDAAA;EACA,qDAAA;AA5JV;AAgKM;EACE,gDAAA;EACA,yBAAA;EACA,kDAAA;AA9JR;AA+JQ;EACE,gDAAA;EACA,kDAAA;AA7JV;AAmKI;EACE,8BAAA;EACA,yBAAA;EACA,gDAAA;AAjKN;AAmKM;;;EAEqB,yBAAA;AAhK3B;AAkKM;;EAC2B,yBAAA;AA/JjC;AAiKM;EACE,yBAAA;AA/JR;AAgKQ;EAAU,yBAAA;AA7JlB","sourcesContent":["// About Us Page Styles - Dark Theme Design\n.about-us-page {\n  font-family: \"Open Sans\", sans-serif !important;\n  color: #ffffff;\n  line-height: 1.6;\n  overflow-x: hidden;\n  background: #0a0c10;\n  min-height: 100vh;\n  margin-top: 0 !important;\n\n  .main-container {\n    margin-top: 0 !important;\n    padding-top: 0 !important;\n  }\n\n  // Page Header\n  .page-header {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 1000;\n    width: 100%;\n    margin-top: 0 !important;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n    background: rgba(10, 12, 16, 0.95);\n    backdrop-filter: blur(20px);\n    transition: all 0.3s ease;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n\n    // Ensure sidebar appears above page header when open\n    ~ :global(.flow-sidebar) {\n      z-index: 1001 !important;\n    }\n\n    &.scrolled {\n      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);\n      background: rgba(10, 12, 16, 0.98);\n    }\n\n    .header-container {\n      max-width: 100%;\n      width: 100%;\n      padding: 0 16px;\n      height: 64px;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 40px;\n\n      @media (max-width: 768px) {\n        padding: 0 16px;\n        gap: 16px;\n        height: 56px;\n      }\n    }\n\n    .header-left {\n      display: flex;\n      align-items: center;\n      gap: 16px;\n      flex-shrink: 0;\n      margin-right: 0;\n    }\n\n    .menu-button {\n      background: none;\n      border: none;\n      color: #ffffff;\n      cursor: pointer;\n      padding: 8px;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      transition: background-color 0.2s;\n      flex-shrink: 0;\n\n      &:hover {\n        background-color: rgba(255, 255, 255, 0.1);\n      }\n\n      mat-icon {\n        font-size: 24px;\n        width: 24px;\n        height: 24px;\n      }\n    }\n\n    .header-logo {\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      flex-shrink: 0;\n\n      img {\n        height: 45px;\n        width: auto;\n        display: block;\n      }\n\n      @media (max-width: 768px) {\n        img {\n          height: 35px;\n        }\n      }\n    }\n\n    .header-nav {\n      display: flex;\n      align-items: center;\n      gap: 40px;\n      flex: 1;\n      justify-content: center;\n      min-width: 0;\n      margin: 0 auto;\n\n      @media (max-width: 1024px) {\n        gap: 24px;\n      }\n\n      @media (max-width: 768px) {\n        display: none;\n      }\n\n      .nav-link {\n        font-family: \"Open Sans\", sans-serif;\n        font-size: 12px;\n        font-weight: 500;\n        text-transform: uppercase;\n        letter-spacing: 0.15em;\n        color: rgba(255, 255, 255, 0.5);\n        text-decoration: none;\n        transition: color 0.3s ease;\n        cursor: pointer;\n        white-space: nowrap;\n        padding: 4px 0;\n\n        &:hover {\n          color: #ffffff;\n        }\n      }\n    }\n\n    .header-actions {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      margin-left: auto;\n      flex-shrink: 0;\n    }\n\n    .theme-toggle-button {\n      border-radius: 999px;\n      padding: 2px;\n      background: transparent;\n      border: none;\n      outline: none;\n      box-shadow: none;\n      cursor: pointer;\n\n      &:focus,\n      &:active,\n      &:focus-visible {\n        border: none;\n        outline: none;\n        box-shadow: none;\n      }\n\n      &:hover {\n        background: transparent;\n      }\n    }\n\n    .theme-toggle-track {\n      width: 48px;\n      height: 26px;\n      border-radius: 999px;\n      background: #e5e7eb;\n      border: none;\n      display: inline-flex;\n      align-items: center;\n      padding: 1px;\n      transition: background-color 0.2s ease;\n    }\n\n    .theme-toggle-track.active {\n      background: #1f2937;\n    }\n\n    .theme-toggle-thumb {\n      width: 22px;\n      height: 22px;\n      border-radius: 50%;\n      background: #ffffff;\n      color: #6b7280;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      transform: translateX(0);\n      transition: transform 0.2s ease, color 0.2s ease, background-color 0.2s ease;\n    }\n\n    .theme-toggle-track.active .theme-toggle-thumb {\n      transform: translateX(22px);\n      color: #ffffff;\n      background: #0f172a;\n    }\n\n    .theme-toggle-thumb mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n\n    /* Keep sun/moon visible against thumb (esp. when global body.theme-dark + MDC conflict) */\n    .theme-toggle-track.active .theme-toggle-thumb mat-icon {\n      color: #ffffff !important;\n    }\n\n    .theme-toggle-track:not(.active) .theme-toggle-thumb mat-icon {\n      color: #6b7280 !important;\n    }\n\n    .btn-get-started {\n      background: #ffffff;\n      color: #000000;\n      padding: 10px 24px;\n      border-radius: 8px;\n      font-size: 14px;\n      font-weight: 700;\n      border: none;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      white-space: nowrap;\n      flex-shrink: 0;\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n      margin-left: 0;\n\n      &:hover {\n        background: rgba(255, 255, 255, 0.95);\n        transform: translateY(-1px);\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n      }\n\n      @media (max-width: 768px) {\n        padding: 8px 16px;\n        font-size: 12px;\n      }\n    }\n  }\n\n  // Container\n  .container {\n    max-width: 1280px;\n    margin: 0 auto;\n    padding: 0 24px !important;\n\n    @media (max-width: 768px) {\n      padding: 0 24px !important;\n    }\n  }\n\n  // Problem Section Container\n  .problem-section .container {\n    max-width: 896px !important;\n  }\n\n  // Insight Section Container\n  .insight-section .container {\n    max-width: 768px !important;\n  }\n\n  // What Section Container\n  .what-section .container {\n    max-width: 1280px !important;\n  }\n\n  // Why Section Container\n  .why-section .container {\n    max-width: 896px !important;\n  }\n\n  // Founder Section Container\n  .founder-section .container {\n    max-width: 896px !important;\n  }\n\n  // Vision Section Container\n  .vision-section .container {\n    max-width: 768px !important;\n  }\n\n  // Values Section Container\n  .values-section .container {\n    max-width: 1280px !important;\n  }\n\n  // Closing Section Container\n  .closing-section .container {\n    max-width: 896px !important;\n  }\n\n  // Section Base Styles\n  .section {\n    padding: 96px 24px !important;\n    position: relative;\n    visibility: visible !important;\n    opacity: 1 !important;\n\n    @media (max-width: 768px) {\n      padding: 60px 24px !important;\n    }\n  }\n\n  // Hero Section\n  .hero-section {\n    min-height: 80vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #0a0c10 !important;\n    color: #ffffff !important;\n    text-align: center;\n    padding: 40px 24px 120px !important;\n    margin-top: 10px;\n    position: relative;\n\n    @media (max-width: 768px) {\n      padding: 32px 24px 80px !important;\n      margin-top: 10px;\n    }\n    overflow: hidden;\n    visibility: visible !important;\n    opacity: 1 !important;\n\n    &::before {\n      content: '';\n      position: absolute;\n      inset: 0;\n      background-image: radial-gradient(circle at 1px 1px, rgba(255, 255, 255, 0.05) 1px, transparent 0);\n      background-size: 40px 40px;\n      pointer-events: none;\n    }\n\n    &::after {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background: linear-gradient(to bottom, rgba(94, 161, 216, 0.1), transparent);\n      pointer-events: none;\n    }\n\n    .hero-content {\n      max-width: 1000px;\n      padding: 0 24px;\n      position: relative;\n      z-index: 2;\n    }\n\n    .hero-badge {\n      background: rgba(94, 161, 216, 0.1) !important;\n      color: #5ea1d8 !important;\n      border: 1px solid rgba(94, 161, 216, 0.3) !important;\n      padding: 4px 12px !important;\n      font-size: 10px !important;\n      font-weight: 700 !important;\n      letter-spacing: 0.2em !important;\n      text-transform: uppercase !important;\n      border-radius: 9999px !important;\n      margin-bottom: 32px !important;\n      display: inline-block !important;\n      opacity: 1 !important;\n      visibility: visible !important;\n    }\n\n    .hero-title {\n      font-family: \"Open Sans\", sans-serif !important;\n      font-size: 64px;\n      font-weight: 700;\n      line-height: 1.1;\n      margin-bottom: 32px;\n      letter-spacing: -0.02em;\n      background: linear-gradient(to right, #ffffff, rgba(148, 163, 184, 1)) !important;\n      -webkit-background-clip: text !important;\n      -webkit-text-fill-color: transparent !important;\n      background-clip: text !important;\n      opacity: 1 !important;\n      visibility: visible !important;\n\n      @media (max-width: 768px) {\n        font-size: 40px;\n      }\n    }\n\n    .hero-subheading {\n      font-size: 24px !important;\n      font-weight: 400 !important;\n      line-height: 1.7 !important;\n      color: #94a3b8 !important;\n      max-width: 800px !important;\n      margin: 0 auto 16px !important;\n      opacity: 1 !important;\n      visibility: visible !important;\n\n      @media (max-width: 768px) {\n        font-size: 20px !important;\n      }\n    }\n\n    .hero-microline {\n      font-size: 18px !important;\n      font-weight: 400 !important;\n      line-height: 1.6 !important;\n      color: #64748b !important;\n      max-width: 800px !important;\n      margin: 0 auto !important;\n      opacity: 1 !important;\n      visibility: visible !important;\n\n      @media (max-width: 768px) {\n        font-size: 16px !important;\n      }\n    }\n  }\n\n  // Problem Section\n  .problem-section {\n    background: rgba(0, 0, 0, 0.5) !important;\n    border-top: 1px solid rgba(255, 255, 255, 0.05) !important;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.05) !important;\n    padding: 96px 24px !important;\n    position: relative !important;\n    opacity: 1 !important;\n    visibility: visible !important;\n\n    .section-heading {\n      font-size: 48px !important;\n      font-weight: 700 !important;\n      margin-bottom: 48px !important;\n      color: #ffffff !important;\n      opacity: 1 !important;\n      visibility: visible !important;\n      line-height: 1.2 !important;\n      letter-spacing: -0.02em !important;\n\n      @media (max-width: 768px) {\n        font-size: 32px !important;\n      }\n    }\n\n    .problem-content {\n      max-width: 896px !important;\n      margin: 0 auto !important;\n    }\n\n    .body-copy {\n      font-size: 18px !important;\n      line-height: 1.8 !important;\n      color: #cbd5e1 !important;\n      margin-bottom: 32px !important;\n      font-weight: 400 !important;\n      opacity: 1 !important;\n      visibility: visible !important;\n    }\n\n    .pull-quote {\n      margin: 48px 0 !important;\n      padding: 32px !important;\n      background: rgba(30, 41, 59, 0.5) !important;\n      border-left: 4px solid #5ea1d8 !important;\n      border-radius: 0 12px 12px 0 !important;\n      opacity: 1 !important;\n      visibility: visible !important;\n\n      p {\n        font-size: 32px !important;\n        font-weight: 500 !important;\n        font-style: italic !important;\n        color: #ffffff !important;\n        margin: 0 !important;\n        line-height: 1.4 !important;\n        opacity: 1 !important;\n        visibility: visible !important;\n\n        @media (max-width: 768px) {\n          font-size: 24px !important;\n        }\n      }\n    }\n  }\n\n  // Insight Section\n  .insight-section {\n    padding: 128px 24px !important;\n    text-align: center;\n    background: #0a0c10 !important;\n    position: relative !important;\n    overflow: hidden !important;\n    visibility: visible !important;\n\n    &::before {\n      content: '';\n      position: absolute;\n      inset: 0;\n      background-image: radial-gradient(circle at 1px 1px, rgba(255, 255, 255, 0.05) 1px, transparent 0);\n      background-size: 40px 40px;\n      pointer-events: none;\n    }\n\n    &::after {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background: linear-gradient(to bottom, rgba(94, 161, 216, 0.1), transparent);\n      pointer-events: none;\n    }\n\n    .insight-content-wrapper {\n      max-width: 768px;\n      margin: 0 auto;\n      position: relative;\n      z-index: 2;\n    }\n\n    .insight-icon {\n      font-size: 48px !important;\n      color: #5ea1d8 !important;\n      margin-bottom: 24px !important;\n      opacity: 1 !important;\n      visibility: visible !important;\n      display: flex !important;\n      align-items: center !important;\n      justify-content: center !important;\n\n      mat-icon {\n        font-size: 48px !important;\n        width: 48px !important;\n        height: 48px !important;\n        color: #5ea1d8 !important;\n      }\n    }\n\n    .insight-title {\n      font-size: 48px;\n      font-weight: 700;\n      line-height: 1.2;\n      color: #ffffff !important;\n      margin-bottom: 32px;\n      letter-spacing: -0.02em;\n      opacity: 1 !important;\n      visibility: visible !important;\n\n      b {\n        font-weight: 700;\n        color: #ffffff !important;\n      }\n\n      @media (max-width: 768px) {\n        font-size: 32px;\n      }\n    }\n\n    .insight-description {\n      font-size: 20px;\n      line-height: 1.8;\n      color: #94a3b8 !important;\n      font-weight: 400;\n      opacity: 1 !important;\n      visibility: visible !important;\n\n      p {\n        margin: 0;\n        color: #94a3b8 !important;\n      }\n    }\n  }\n\n  // What Section\n  .what-section {\n    background: rgba(0, 0, 0, 0.4) !important;\n    padding: 96px 24px !important;\n    visibility: visible !important;\n\n    .section-label {\n      font-size: 12px;\n      font-weight: 700;\n      text-transform: uppercase;\n      letter-spacing: 0.1em;\n      color: #5ea1d8 !important;\n      text-align: center;\n      margin-bottom: 64px;\n      opacity: 1 !important;\n      visibility: visible !important;\n    }\n\n    .feature-cards-grid {\n      display: grid;\n      grid-template-columns: repeat(3, 1fr);\n      gap: 32px;\n      margin-bottom: 96px;\n\n      @media (max-width: 992px) {\n        grid-template-columns: 1fr;\n      }\n    }\n\n    .feature-card {\n      background: rgba(255, 255, 255, 0.05) !important;\n      border: 1px solid rgba(255, 255, 255, 0.1) !important;\n      padding: 32px !important;\n      border-radius: 16px !important;\n      transition: all 0.3s ease !important;\n\n      &:hover {\n        border-color: rgba(94, 161, 216, 0.5) !important;\n        background: rgba(255, 255, 255, 0.08) !important;\n      }\n\n      .card-icon {\n        width: 48px !important;\n        height: 48px !important;\n        background: rgba(94, 161, 216, 0.2) !important;\n        border-radius: 8px !important;\n        display: flex !important;\n        align-items: center !important;\n        justify-content: center !important;\n        margin-bottom: 24px !important;\n        font-size: 24px !important;\n        transition: transform 0.3s ease !important;\n\n        mat-icon {\n          font-size: 28px !important;\n          width: 28px !important;\n          height: 28px !important;\n          color: #5ea1d8 !important;\n        }\n      }\n\n      &:hover .card-icon {\n        transform: scale(1.1);\n      }\n\n      .card-title {\n        font-size: 20px;\n        font-weight: 700;\n        margin-bottom: 16px;\n        color: #ffffff !important;\n        opacity: 1 !important;\n        visibility: visible !important;\n      }\n\n      .card-copy {\n        font-size: 16px;\n        line-height: 1.7;\n        color: #94a3b8 !important;\n        font-weight: 400;\n        opacity: 1 !important;\n        visibility: visible !important;\n      }\n    }\n\n    .protocol-heading {\n      font-size: 30px !important;\n      font-weight: 700 !important;\n      margin-bottom: 64px !important;\n      color: #ffffff !important;\n      text-align: left !important;\n      margin-top: 0 !important;\n      opacity: 1 !important;\n      visibility: visible !important;\n    }\n\n    .steps-container {\n      display: flex;\n      flex-direction: row;\n      gap: 32px;\n      position: relative;\n\n      @media (max-width: 992px) {\n        flex-direction: column;\n      }\n    }\n\n    .steps-microline {\n      font-size: 16px !important;\n      font-weight: 400 !important;\n      line-height: 1.6 !important;\n      color: #64748b !important;\n      text-align: center !important;\n      margin-top: 48px !important;\n      margin-bottom: 0 !important;\n      opacity: 1 !important;\n      visibility: visible !important;\n    }\n\n    .step-card {\n      flex: 1;\n      position: relative;\n      padding-top: 60px !important;\n      padding-left: 0 !important;\n      padding-right: 16px !important;\n\n      .step-number-wrapper {\n        position: relative !important;\n        margin-bottom: 24px !important;\n        height: 40px !important;\n      }\n\n      .step-number {\n        font-size: 72px !important;\n        font-weight: 700 !important;\n        color: rgba(255, 255, 255, 0.1) !important;\n        position: absolute !important;\n        top: -60px !important;\n        left: 0 !important;\n        line-height: 1 !important;\n        opacity: 1 !important;\n        visibility: visible !important;\n        z-index: 0 !important;\n        pointer-events: none !important;\n      }\n\n      .step-content {\n        position: relative !important;\n        z-index: 1 !important;\n        margin-top: 0 !important;\n\n        .step-title {\n          font-size: 20px !important;\n          font-weight: 700 !important;\n          margin-bottom: 8px !important;\n          margin-top: 0 !important;\n          color: #ffffff !important;\n          opacity: 1 !important;\n          visibility: visible !important;\n          position: relative !important;\n          z-index: 2 !important;\n        }\n\n        .step-description {\n          font-size: 16px !important;\n          line-height: 1.7 !important;\n          color: #94a3b8 !important;\n          font-weight: 400 !important;\n          opacity: 1 !important;\n          visibility: visible !important;\n          position: relative !important;\n          z-index: 2 !important;\n        }\n      }\n\n      &:nth-child(n+2) .step-content .step-description {\n        padding-left: 0 !important;\n        text-indent: 0 !important;\n        position: relative !important;\n\n        &::before {\n          content: '>' !important;\n          position: absolute !important;\n          left: -20px !important;\n          top: 0 !important;\n          color: #5ea1d8 !important;\n          font-size: 16px !important;\n          font-weight: 700 !important;\n          opacity: 1 !important;\n          visibility: visible !important;\n          line-height: 1.7 !important;\n        }\n      }\n    }\n  }\n\n  // Who Section\n  .who-section {\n    background: #0a0c10 !important;\n    border-top: 1px solid rgba(255, 255, 255, 0.05) !important;\n    padding: 96px 24px !important;\n    visibility: visible !important;\n\n    .section-heading {\n      font-size: 32px !important;\n      font-weight: 700 !important;\n      margin-bottom: 48px !important;\n      text-align: center !important;\n      color: #ffffff !important;\n      opacity: 1 !important;\n      visibility: visible !important;\n    }\n\n    .who-grid {\n      display: grid;\n      grid-template-columns: repeat(4, 1fr);\n      gap: 24px;\n\n      @media (max-width: 992px) {\n        grid-template-columns: repeat(2, 1fr);\n      }\n\n      @media (max-width: 768px) {\n        grid-template-columns: 1fr;\n      }\n    }\n\n    .who-card {\n      background: transparent !important;\n      border: 1px solid rgba(255, 255, 255, 0.1) !important;\n      padding: 24px !important;\n      border-radius: 12px !important;\n      text-align: center !important;\n      transition: all 0.3s ease !important;\n\n      &:hover {\n        background: rgba(255, 255, 255, 0.05) !important;\n        border-color: rgba(255, 255, 255, 0.15) !important;\n      }\n\n      .who-icon {\n        font-size: 32px;\n        margin-bottom: 16px;\n        display: flex !important;\n        align-items: center !important;\n        justify-content: center !important;\n\n        mat-icon {\n          font-size: 40px !important;\n          width: 40px !important;\n          height: 40px !important;\n          color: #5ea1d8 !important;\n        }\n      }\n\n      .who-title {\n        font-size: 18px;\n        font-weight: 700;\n        margin-bottom: 8px;\n        color: #ffffff !important;\n        opacity: 1 !important;\n        visibility: visible !important;\n      }\n\n      .who-copy {\n        font-size: 14px;\n        line-height: 1.6;\n        color: #94a3b8 !important;\n        font-weight: 400;\n        opacity: 1 !important;\n        visibility: visible !important;\n      }\n    }\n  }\n\n  // Why Section\n  .why-section {\n    background: rgba(15, 23, 42, 0.2) !important;\n    padding: 96px 24px !important;\n    visibility: visible !important;\n\n    .section-heading {\n      font-size: 32px !important;\n      font-weight: 700 !important;\n      margin-bottom: 48px !important;\n      text-align: center !important;\n      color: #ffffff !important;\n      opacity: 1 !important;\n      visibility: visible !important;\n    }\n\n    .comparison-table {\n      max-width: 1000px;\n      margin: 0 auto;\n      background: rgba(0, 0, 0, 0.4) !important;\n      border: 1px solid rgba(255, 255, 255, 0.1) !important;\n      border-radius: 16px;\n      overflow: hidden;\n    }\n\n    .comparison-header,\n    .comparison-row {\n      display: grid;\n      grid-template-columns: 2fr 1fr 1fr;\n      gap: 1px;\n      background: transparent;\n    }\n\n    .comparison-header {\n      background: transparent;\n\n      .comparison-col-header {\n        padding: 24px;\n        font-weight: 700;\n        font-size: 12px;\n        text-transform: uppercase;\n        letter-spacing: 0.1em;\n        color: #94a3b8 !important;\n        text-align: left;\n        opacity: 1 !important;\n        visibility: visible !important;\n\n        &:last-child {\n          color: #5ea1d8 !important;\n        }\n      }\n    }\n\n    .comparison-row {\n      background: transparent;\n      border-top: 1px solid rgba(255, 255, 255, 0.1);\n\n      .comparison-label {\n        padding: 24px;\n        font-weight: 500;\n        color: #ffffff !important;\n        font-size: 16px;\n        opacity: 1 !important;\n        visibility: visible !important;\n      }\n\n      .comparison-cell {\n        padding: 24px;\n        text-align: left;\n        color: #94a3b8 !important;\n        font-style: italic;\n        font-size: 16px;\n        opacity: 1 !important;\n        visibility: visible !important;\n\n        &.highlight {\n          color: #5ea1d8 !important;\n          font-weight: 700;\n          font-style: normal;\n        }\n      }\n    }\n  }\n\n  // Founder Section\n  .founder-section {\n    background: #0a0c10 !important;\n    border-top: 1px solid rgba(255, 255, 255, 0.05) !important;\n    padding: 96px 24px !important;\n    visibility: visible !important;\n\n    .founder-content-wrapper {\n      max-width: 1400px !important;\n      margin: 0 auto !important;\n      display: grid !important;\n      grid-template-columns: 400px 1fr !important;\n      gap: 80px !important;\n      align-items: flex-start !important;\n\n      @media (max-width: 992px) {\n        grid-template-columns: 1fr !important;\n        gap: 48px !important;\n      }\n    }\n\n    .founder-image-container {\n      display: flex !important;\n      flex-direction: column !important;\n      align-items: flex-start !important;\n      justify-content: flex-start !important;\n      margin: 0 !important;\n      padding: 0 !important;\n\n      .founder-image {\n        width: 100% !important;\n        max-width: 400px !important;\n        aspect-ratio: 3 / 4 !important;\n        border-radius: 12px !important;\n        overflow: hidden !important;\n        filter: grayscale(100%) !important;\n        transition: filter 0.5s ease !important;\n        background: #4a5568 !important;\n        background-image: url('../../../assets/images/founder.png') !important;\n        background-size: cover !important;\n        background-position: center !important;\n        flex-shrink: 0 !important;\n        margin: 0 !important;\n        padding: 0 !important;\n        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4) !important;\n\n        &:hover {\n          filter: grayscale(0%) !important;\n        }\n\n        @media (max-width: 992px) {\n          max-width: 100% !important;\n          aspect-ratio: 3 / 4 !important;\n        }\n      }\n\n      .founder-label {\n        font-family: \"Open Sans\", sans-serif !important;\n        font-size: 24px !important;\n        font-weight: 700 !important;\n        color: #ffffff !important;\n        margin-top: 24px !important;\n        margin-bottom: 8px !important;\n        margin-left: 0 !important;\n        margin-right: 0 !important;\n        padding: 0 !important;\n        opacity: 1 !important;\n        visibility: visible !important;\n        line-height: 1.2 !important;\n      }\n\n      .founder-name {\n        font-family: \"Open Sans\", sans-serif !important;\n        font-size: 16px !important;\n        color: rgba(255, 255, 255, 0.7) !important;\n        margin: 0 !important;\n        padding: 0 !important;\n        opacity: 1 !important;\n        visibility: visible !important;\n        line-height: 1.5 !important;\n      }\n    }\n\n    .founder-text-container {\n      display: flex !important;\n      flex-direction: column !important;\n      justify-content: flex-start !important;\n      align-items: flex-start !important;\n      margin: 0 !important;\n      padding: 0 !important;\n\n      .founder-quote-block {\n        margin: 2px 0 !important;\n        margin-bottom: 16px !important;\n        padding: 10px !important;\n        background: rgba(30, 41, 59, 0.5) !important;\n        border-left: 4px solid #5ea1d8 !important;\n        border-radius: 0 12px 12px 0 !important;\n        opacity: 1 !important;\n        visibility: visible !important;\n        width: 100% !important;\n\n        p {\n          font-size: 15px !important;\n          font-weight: 400 !important;\n          font-style: italic !important;\n          color: #ffffff !important;\n          margin: 0 !important;\n          line-height: 1.8 !important;\n          opacity: 1 !important;\n          visibility: visible !important;\n        }\n      }\n\n      .founder-heading {\n        font-family: \"Open Sans\", sans-serif !important;\n        font-size: 24px !important;\n        font-weight: 700 !important;\n        color: #ffffff !important;\n        margin-bottom: 16px !important;\n        margin-top: 0 !important;\n        opacity: 1 !important;\n        visibility: visible !important;\n\n        @media (max-width: 768px) {\n          font-size: 20px !important;\n        }\n      }\n\n      .founder-text {\n        font-family: \"Open Sans\", sans-serif !important;\n        font-size: 16px !important;\n        line-height: 1.75 !important;\n        margin-bottom: 16px !important;\n        margin-top: 0 !important;\n        margin-left: 0 !important;\n        margin-right: 0 !important;\n        padding: 0 !important;\n        font-weight: 400 !important;\n        color: rgba(255, 255, 255, 0.9) !important;\n        opacity: 1 !important;\n        visibility: visible !important;\n\n        &:last-of-type {\n          margin-bottom: 16px !important;\n        }\n\n        strong {\n          font-family: \"Open Sans\", sans-serif !important;\n          font-size: 16px !important;\n          font-weight: 700 !important;\n          font-style: italic !important;\n          color: #ffffff !important;\n        }\n      }\n\n      .founder-quote {\n        font-family: \"Open Sans\", sans-serif !important;\n        font-size: 18px !important;\n        font-style: italic !important;\n        font-weight: 400 !important;\n        color: rgba(255, 255, 255, 0.9) !important;\n        margin-top: 0 !important;\n        padding-top: 0 !important;\n        border-top: none !important;\n        opacity: 1 !important;\n        visibility: visible !important;\n      }\n    }\n  }\n\n  // Vision Section\n  .vision-section {\n    background: rgba(94, 161, 216, 0.05) !important;\n    padding: 96px 24px !important;\n    text-align: center;\n    visibility: visible !important;\n\n    .section-label {\n      font-size: 12px !important;\n      font-weight: 700 !important;\n      text-transform: uppercase !important;\n      letter-spacing: 0.1em !important;\n      color: #5ea1d8 !important;\n      margin-bottom: 32px !important;\n      opacity: 1 !important;\n      visibility: visible !important;\n    }\n\n    .section-heading {\n      font-size: 32px !important;\n      font-weight: 500 !important;\n      line-height: 1.6 !important;\n      margin-bottom: 48px !important;\n      color: #ffffff !important;\n      max-width: 900px !important;\n      margin-left: auto !important;\n      margin-right: auto !important;\n      opacity: 1 !important;\n      visibility: visible !important;\n\n      @media (max-width: 768px) {\n        font-size: 24px !important;\n      }\n    }\n\n    .vision-content {\n      opacity: 1 !important;\n      visibility: visible !important;\n    }\n\n    .vision-text {\n      font-size: 16px !important;\n      line-height: 1.75 !important;\n      color: rgba(255, 255, 255, 0.9) !important;\n      margin-bottom: 32px !important;\n      max-width: 800px !important;\n      margin-left: auto !important;\n      margin-right: auto !important;\n      text-align: center !important;\n      opacity: 1 !important;\n      visibility: visible !important;\n    }\n\n    .vision-quote {\n      max-width: 672px !important;\n      margin: 0 auto !important;\n      padding-top: 32px !important;\n      border-top: 1px solid rgba(255, 255, 255, 0.1) !important;\n      font-style: italic !important;\n      color: #94a3b8 !important;\n      font-size: 18px !important;\n      opacity: 1 !important;\n      visibility: visible !important;\n\n      p {\n        color: #94a3b8 !important;\n        opacity: 1 !important;\n        visibility: visible !important;\n      }\n      line-height: 1.8;\n      opacity: 1 !important;\n      visibility: visible !important;\n    }\n  }\n\n  // Values Section\n  .values-section {\n    background: #0a0c10 !important;\n    padding: 96px 24px !important;\n    visibility: visible !important;\n\n    .section-heading {\n      text-align: center !important;\n      margin-bottom: 64px !important;\n      color: #ffffff !important;\n      font-size: 32px !important;\n      font-weight: 700 !important;\n    }\n\n    .values-grid {\n      display: grid;\n      grid-template-columns: repeat(5, 1fr);\n      gap: 48px;\n      max-width: 1400px;\n      margin: 0 auto;\n\n      @media (max-width: 1200px) {\n        grid-template-columns: repeat(3, 1fr);\n      }\n\n      @media (max-width: 992px) {\n        grid-template-columns: repeat(2, 1fr);\n      }\n\n      @media (max-width: 768px) {\n        grid-template-columns: 1fr;\n      }\n    }\n\n    .value-item {\n      text-align: center;\n\n      .value-icon-large {\n        font-size: 48px;\n        color: #5ea1d8;\n        margin-bottom: 16px;\n        display: flex !important;\n        align-items: center !important;\n        justify-content: center !important;\n\n        mat-icon {\n          font-size: 48px !important;\n          width: 48px !important;\n          height: 48px !important;\n          color: #5ea1d8 !important;\n        }\n      }\n\n      .value-title {\n        font-size: 18px;\n        font-weight: 700;\n        color: #ffffff !important;\n        margin: 0;\n        opacity: 1 !important;\n        visibility: visible !important;\n      }\n    }\n  }\n\n  // Closing Section\n  .closing-section {\n    background: #0a0c10 !important;\n    border-top: 1px solid rgba(255, 255, 255, 0.05) !important;\n    padding: 128px 24px !important;\n    text-align: center;\n    position: relative;\n    overflow: hidden;\n    visibility: visible !important;\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 50%;\n      transform: translateX(-50%);\n      width: 800px;\n      height: 400px;\n      background: rgba(94, 161, 216, 0.2);\n      filter: blur(120px);\n      border-radius: 50%;\n      z-index: 0;\n      pointer-events: none;\n    }\n\n    .closing-content {\n      max-width: 900px;\n      margin: 0 auto;\n      position: relative;\n      z-index: 1;\n    }\n\n    .closing-intro {\n      font-size: 20px;\n      font-weight: 400;\n      font-style: italic !important;\n      line-height: 1.8;\n      color: #94a3b8 !important;\n      margin-bottom: 32px;\n      max-width: 800px;\n      margin-left: auto;\n      margin-right: auto;\n      opacity: 1 !important;\n      visibility: visible !important;\n\n      @media (max-width: 768px) {\n        font-size: 18px;\n      }\n    }\n\n    .closing-statement {\n      font-size: 48px;\n      font-weight: 700;\n      margin-bottom: 16px;\n      line-height: 1.2;\n      letter-spacing: -0.02em;\n      color: #ffffff !important;\n      opacity: 1 !important;\n      visibility: visible !important;\n\n      @media (max-width: 768px) {\n        font-size: 32px;\n      }\n    }\n\n    .closing-subtext {\n      font-size: 16px;\n      font-weight: 400;\n      line-height: 1.6;\n      color: rgba(255, 255, 255, 0.7) !important;\n      margin-bottom: 40px;\n      opacity: 1 !important;\n      visibility: visible !important;\n\n      @media (max-width: 768px) {\n        font-size: 14px;\n      }\n    }\n\n    .cta-buttons {\n      display: flex;\n      gap: 16px;\n      justify-content: center;\n      flex-wrap: wrap;\n    }\n\n    .btn-primary,\n    .btn-secondary {\n      font-family: \"Open Sans\", sans-serif !important;\n      padding: 18px 40px;\n      font-size: 18px;\n      font-weight: 700;\n      border-radius: 12px;\n      border: none;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      height: 56px;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    .btn-primary {\n      background: #5ea1d8;\n      color: #ffffff;\n      box-shadow: 0 10px 25px rgba(94, 161, 216, 0.25);\n\n      &:hover {\n        background: rgba(94, 161, 216, 0.9);\n        transform: translateY(-2px);\n        box-shadow: 0 15px 35px rgba(94, 161, 216, 0.35);\n      }\n    }\n\n    .btn-secondary {\n      background: rgba(255, 255, 255, 0.1);\n      color: #ffffff;\n      border: 1px solid rgba(255, 255, 255, 0.1);\n\n      &:hover {\n        background: rgba(255, 255, 255, 0.2);\n        border-color: rgba(255, 255, 255, 0.2);\n        transform: translateY(-2px);\n      }\n    }\n  }\n\n  // Footer\n  .footer {\n    background: #000000;\n    color: #ffffff;\n    padding: 14px 0;\n    border-top: 1px solid rgba(255, 255, 255, 0.05);\n\n    .copy-rights {\n      max-width: 1400px;\n      margin: 0 auto;\n      padding: 0 24px;\n      width: 100%;\n\n      .row {\n        display: flex;\n        align-items: center;\n        margin: 0;\n        width: 100%;\n\n        @media (max-width: 768px) {\n          flex-direction: column;\n          align-items: flex-start;\n          gap: 16px;\n        }\n      }\n\n      .col-md-5,\n      .col-md-7,\n      .col-12 {\n        padding: 0;\n        display: flex;\n        align-items: center;\n\n        @media (max-width: 768px) {\n          width: 100%;\n          justify-content: flex-start;\n        }\n      }\n\n      .col-md-5 {\n        @media (min-width: 769px) {\n          justify-content: flex-start;\n        }\n      }\n\n      .col-md-7 {\n        @media (min-width: 769px) {\n          justify-content: flex-end;\n        }\n      }\n    }\n\n    .cpyrgt {\n      color: #64748b !important;\n      list-style: none;\n      padding: 0;\n      margin: 0;\n      display: flex;\n      align-items: center;\n      font-size: 14px;\n      line-height: 1.5;\n      width: 100%;\n\n      @media (max-width: 768px) {\n        flex-wrap: wrap;\n      }\n\n      li {\n        color: #64748b !important;\n        margin: 0;\n        padding: 0;\n        display: flex;\n        align-items: center;\n        flex-wrap: wrap;\n\n        a {\n          color: #64748b !important;\n          text-decoration: none;\n          margin-left: 4px;\n\n          &:hover {\n            color: #5ea1d8 !important;\n            text-decoration: underline;\n          }\n        }\n      }\n    }\n\n    .f-menu-right {\n      display: flex;\n      list-style: none;\n      padding: 0;\n      margin: 0;\n      align-items: center;\n      justify-content: flex-end;\n      flex-wrap: wrap;\n      gap: 0;\n      width: 100%;\n\n      @media (max-width: 768px) {\n        justify-content: flex-start;\n        flex-wrap: wrap;\n      }\n\n      li {\n        padding: 0;\n        margin: 0;\n        display: flex;\n        align-items: center;\n\n        &:not(:last-child)::after {\n          content: '|';\n          color: rgba(100, 116, 139, 0.5);\n          margin: 0 12px;\n          font-size: 14px;\n        }\n\n        a {\n          color: #64748b !important;\n          font-size: 14px;\n          text-decoration: none;\n          transition: color 0.3s ease;\n          padding: 4px 0;\n          white-space: nowrap;\n\n          &:hover {\n            color: #5ea1d8 !important;\n          }\n        }\n      }\n    }\n\n    h6 {\n      color: #94a3b8 !important;\n      font-weight: 700 !important;\n      font-size: 12px !important;\n      text-transform: uppercase !important;\n      letter-spacing: 0.1em !important;\n      margin-bottom: 16px !important;\n    }\n\n    ul {\n      li {\n        a {\n          color: #64748b !important;\n          font-size: 14px !important;\n\n          &:hover {\n            color: #5ea1d8 !important;\n          }\n        }\n      }\n    }\n\n    p {\n      color: #475569 !important;\n      font-size: 14px !important;\n    }\n\n    .material-symbols-outlined {\n      color: #475569 !important;\n\n      &:hover {\n        color: #ffffff !important;\n      }\n    }\n  }\n\n  // Responsive Design\n  @media (max-width: 768px) {\n    .container {\n      padding: 0 24px !important;\n    }\n\n    .section {\n      padding: 60px 24px !important;\n    }\n\n    .cta-buttons {\n      flex-direction: column;\n\n      .btn-primary,\n      .btn-secondary {\n        width: 100%;\n      }\n    }\n  }\n}\n\n// Override global mobile footer hiding for About Us page\n@media screen and (max-width: 992px) {\n  :host footer,\n  :host .footer,\n  app-about-us footer,\n  app-about-us .footer {\n    display: block !important;\n    visibility: visible !important;\n  }\n}\n\n// ============================================================\n// Light Mode Overrides\n// Rhythm: Blue hero → light sections → blue insight → light sections → blue closing CTA\n// ============================================================\nbody.theme-light {\n  .about-us-page {\n    background: #f8fafc !important;\n    color: #0f172a !important;\n\n    // ── Header ──────────────────────────────────────────────\n    .page-header {\n      background: rgba(255, 255, 255, 0.95) !important;\n      border-bottom-color: rgba(0, 0, 0, 0.08) !important;\n      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08) !important;\n      backdrop-filter: blur(20px) !important;\n\n      &.scrolled {\n        background: rgba(255, 255, 255, 0.98) !important;\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;\n      }\n\n      .menu-button {\n        color: #0f172a !important;\n        &:hover { background-color: rgba(0, 0, 0, 0.06) !important; }\n      }\n\n      .header-nav .nav-link {\n        color: rgba(15, 23, 42, 0.5) !important;\n        &:hover { color: #0f172a !important; }\n      }\n\n      .btn-get-started {\n        background: #5ea1d8 !important;\n        color: #ffffff !important;\n        font-weight: 700 !important;\n        &:hover {\n          background: #4a8cc5 !important;\n          box-shadow: 0 4px 12px rgba(94, 161, 216, 0.35) !important;\n        }\n      }\n    }\n\n    // ── Hero Section — Flowchest blue ───────────────────────\n    .hero-section {\n      background: linear-gradient(160deg, #90c3e8 0%, #70aedf 55%, #5ea1d8 100%) !important;\n      color: #ffffff !important;\n\n      &::before {\n        background-image: radial-gradient(circle at 1px 1px, rgba(255, 255, 255, 0.12) 1px, transparent 0) !important;\n      }\n\n      &::after {\n        background: linear-gradient(to bottom, rgba(255, 255, 255, 0.06), transparent) !important;\n      }\n\n      .hero-badge {\n        background: rgba(255, 255, 255, 0.15) !important;\n        color: #ffffff !important;\n        border-color: rgba(255, 255, 255, 0.35) !important;\n      }\n\n      .hero-title {\n        background: linear-gradient(to right, #ffffff, rgba(255, 255, 255, 0.85)) !important;\n        -webkit-background-clip: text !important;\n        -webkit-text-fill-color: transparent !important;\n        background-clip: text !important;\n      }\n\n      .hero-subheading { color: rgba(255, 255, 255, 0.88) !important; }\n      .hero-microline  { color: rgba(255, 255, 255, 0.7) !important; }\n    }\n\n    // ── Problem Section — light ──────────────────────────────\n    .problem-section {\n      background: #ffffff !important;\n      border-top-color: rgba(94, 161, 216, 0.15) !important;\n      border-bottom-color: rgba(94, 161, 216, 0.15) !important;\n\n      .section-heading { color: #0f172a !important; }\n      .body-copy       { color: #475569 !important; }\n\n      .pull-quote {\n        background: rgba(94, 161, 216, 0.06) !important;\n        border-left-color: #5ea1d8 !important;\n        p { color: #0f172a !important; }\n      }\n    }\n\n    // ── Insight Section — Flowchest blue ────────────────────\n    .insight-section {\n      background: linear-gradient(160deg, #90c3e8 0%, #70aedf 55%, #5ea1d8 100%) !important;\n\n      &::before {\n        background-image: radial-gradient(circle at 1px 1px, rgba(255, 255, 255, 0.12) 1px, transparent 0) !important;\n      }\n\n      &::after {\n        background: linear-gradient(to bottom, rgba(255, 255, 255, 0.06), transparent) !important;\n      }\n\n      .insight-icon mat-icon { color: rgba(255, 255, 255, 0.9) !important; }\n\n      .insight-title {\n        color: #ffffff !important;\n        b { color: #ffffff !important; }\n      }\n\n      .insight-description {\n        color: rgba(255, 255, 255, 0.85) !important;\n        p { color: rgba(255, 255, 255, 0.85) !important; }\n      }\n    }\n\n    // ── What / Protocol Section — light ─────────────────────\n    .what-section {\n      background: #f8fafc !important;\n\n      .section-label { color: #5ea1d8 !important; }\n\n      .feature-card {\n        background: #ffffff !important;\n        border-color: rgba(94, 161, 216, 0.15) !important;\n        box-shadow: 0 2px 8px rgba(94, 161, 216, 0.06) !important;\n\n        &:hover {\n          border-color: rgba(94, 161, 216, 0.4) !important;\n          background: #ffffff !important;\n          box-shadow: 0 4px 16px rgba(94, 161, 216, 0.12) !important;\n        }\n\n        .card-icon { background: rgba(94, 161, 216, 0.1) !important; }\n        .card-title { color: #0f172a !important; }\n        .card-copy  { color: #64748b !important; }\n      }\n\n      .protocol-heading { color: #0f172a !important; }\n      .steps-microline  { color: #94a3b8 !important; }\n\n      .step-card {\n        .step-number { color: rgba(58, 122, 181, 0.35) !important; }\n\n        .step-content {\n          .step-title       { color: #0f172a !important; }\n          .step-description { color: #64748b !important; }\n        }\n      }\n    }\n\n    // ── Who Section — light ──────────────────────────────────\n    .who-section {\n      background: #ffffff !important;\n      border-top-color: rgba(94, 161, 216, 0.12) !important;\n\n      .section-heading { color: #0f172a !important; }\n\n      .who-card {\n        border-color: rgba(94, 161, 216, 0.15) !important;\n\n        &:hover {\n          background: rgba(94, 161, 216, 0.04) !important;\n          border-color: rgba(94, 161, 216, 0.3) !important;\n        }\n\n        .who-title { color: #0f172a !important; }\n        .who-copy  { color: #64748b !important; }\n      }\n    }\n\n    // ── Why Section (comparison table) — light ───────────────\n    .why-section {\n      background: #f8fafc !important;\n\n      .section-heading { color: #0f172a !important; }\n\n      .comparison-table {\n        background: #ffffff !important;\n        border-color: rgba(94, 161, 216, 0.2) !important;\n        box-shadow: 0 2px 12px rgba(94, 161, 216, 0.08) !important;\n      }\n\n      .comparison-header .comparison-col-header {\n        color: #64748b !important;\n        &:last-child { color: #5ea1d8 !important; }\n      }\n\n      .comparison-row {\n        border-top-color: rgba(94, 161, 216, 0.1) !important;\n\n        .comparison-label { color: #0f172a !important; }\n\n        .comparison-cell {\n          color: #64748b !important;\n          &.highlight { color: #5ea1d8 !important; }\n        }\n      }\n    }\n\n    // ── Founder Section — light ──────────────────────────────\n    .founder-section {\n      background: #ffffff !important;\n      border-top-color: rgba(94, 161, 216, 0.12) !important;\n\n      .founder-label { color: #0f172a !important; }\n      .founder-name  { color: #64748b !important; }\n\n      .founder-quote-block {\n        background: rgba(94, 161, 216, 0.06) !important;\n        border-left-color: #5ea1d8 !important;\n        p { color: #0f172a !important; }\n      }\n\n      .founder-heading { color: #0f172a !important; }\n      .founder-text {\n        color: #334155 !important;\n        strong { color: #0f172a !important; }\n      }\n      .founder-quote { color: #475569 !important; }\n    }\n\n    // ── Vision Section — soft blue wash ──────────────────────\n    .vision-section {\n      background: rgba(94, 161, 216, 0.07) !important;\n\n      .section-label    { color: #5ea1d8 !important; }\n      .section-heading  { color: #0f172a !important; }\n      .vision-text      { color: #334155 !important; }\n\n      .vision-quote {\n        border-top-color: rgba(94, 161, 216, 0.2) !important;\n        color: #475569 !important;\n        p { color: #475569 !important; }\n      }\n    }\n\n    // ── Values Section — light ───────────────────────────────\n    .values-section {\n      background: #f8fafc !important;\n\n      .section-heading { color: #0f172a !important; }\n      .value-title     { color: #0f172a !important; }\n    }\n\n    // ── Closing / CTA Section — Flowchest blue ───────────────\n    .closing-section {\n      background: linear-gradient(160deg, #90c3e8 0%, #70aedf 55%, #5ea1d8 100%) !important;\n      border-top: none !important;\n\n      &::before {\n        background: rgba(255, 255, 255, 0.08) !important;\n      }\n\n      .closing-intro     { color: rgba(255, 255, 255, 0.82) !important; }\n      .closing-statement { color: #ffffff !important; }\n      .closing-subtext   { color: rgba(255, 255, 255, 0.75) !important; }\n\n      .btn-primary {\n        background: #ffffff !important;\n        color: #5ea1d8 !important;\n        &:hover {\n          background: rgba(255, 255, 255, 0.92) !important;\n          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15) !important;\n        }\n      }\n\n      .btn-secondary {\n        background: rgba(255, 255, 255, 0.12) !important;\n        color: #ffffff !important;\n        border-color: rgba(255, 255, 255, 0.35) !important;\n        &:hover {\n          background: rgba(255, 255, 255, 0.22) !important;\n          border-color: rgba(255, 255, 255, 0.55) !important;\n        }\n      }\n    }\n\n    // ── Footer ───────────────────────────────────────────────\n    .footer {\n      background: #f1f5f9 !important;\n      color: #475569 !important;\n      border-top-color: rgba(0, 0, 0, 0.08) !important;\n\n      .cpyrgt li,\n      .cpyrgt li a,\n      .f-menu-right li a { color: #64748b !important; }\n\n      .cpyrgt li a:hover,\n      .f-menu-right li a:hover { color: #5ea1d8 !important; }\n\n      .material-symbols-outlined {\n        color: #94a3b8 !important;\n        &:hover { color: #5ea1d8 !important; }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
